import React, { Component , Fragment } from "react";
import TeamFull from "../elements/Team_full";
import FooterTwo from "../component/footer/FooterTwo";
import Header from "../component/header/Header";
import { FiCheck, FiClock, FiUser, FiMonitor, FiRadio, FiDownload, FiVideo, FiCheckCircle, FiPackage} from "react-icons/fi";
import { GoRocket } from "react-icons/go";
import { FaGraduationCap, FaPhone, FaRunning, FaEye, FaWhatsapp, FaPaypal, FaFacebookSquare, FaStar, FaChevronCircleRight, FaLinkedin, FaCalendarWeek, FaFilm, FaCheckCircle } from "react-icons/fa";
import { BsCircle, BsArrowLeftCircle, BsSun, BsFillPlayCircleFill, BsCloudSunFill } from "react-icons/bs";
import { IoCloseCircleOutline, IoCard } from "react-icons/io5";
import { AiOutlineDown, AiOutlineRight, AiOutlineClose } from "react-icons/ai";
import { MdWork, MdEmail, MdPayments, MdModeNight, MdOutlineVideoLabel } from "react-icons/md";
import Typical from 'react-typical';    
import Modal from "react-bootstrap/Modal";
import 'custom-react-accordion/dist/Accordion.css'
import NonPassiveTouchTarget from "./NonPassiveTouchTarget";
import TouchCarousel, { clamp } from "react-touch-carousel";
import touchWithMouseHOC from "react-touch-carousel/lib/touchWithMouseHOC";
import "./styles.css";
import data from "./data";
import data2, {dataUSA} from "./data2";
import cx from "classnames";
import AOS from 'aos';
import 'aos/dist/aos.css';
import TestimonialOne from "../blocks/testimonial/TestimonialOne";
import ReactCountryFlag from "react-country-flag";
import axios from 'axios';
import Selectrix from "react-selectrix";
import 'react-toastify/dist/ReactToastify.css';
import TestimonialTree from "../blocks/testimonial/TestimonialTree";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Spinner from 'react-bootstrap/Spinner';
import ReactPlayer from "react-player";
import FlipCountdown from '@rumess/react-flip-countdown';
import Plataforma from "../component/dojopy/Plataforma";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import PreguntasEmpleo from "../component/dojopy/PreguntasEmpleo";
import { GiPlatform } from "react-icons/gi";
import { FaFilePdf } from "react-icons/fa6";
import { FaRegFilePdf } from "react-icons/fa6";
import { CiCalendar } from "react-icons/ci";
import { FcConferenceCall } from "react-icons/fc";
import { MdWorkOutline, MdWatchLater } from "react-icons/md";
import { TbWorldCheck } from "react-icons/tb";
import { IoVideocamOutline } from "react-icons/io5";
import { IoIosDocument, IoMdCall } from "react-icons/io";
import { HiMiniPencilSquare } from "react-icons/hi2";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {AccordionWrapper, AccordionItem} from "custom-react-accordion";




const cardSize = 300;
const cardSize2 = 280;
const cardPadCount = 2;
const carouselWidth = clamp(window.innerWidth, 0, 960);

const FECHAS_EVENTO = [
    'Hoy, 7:00 PM',
    'Jueves, 14 de diciembre, 7:00 PM',
    'Viernes, 15 de diciembre, 7:00 PM',
]


AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 10, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  });

// const then = moment('05 26 2019, 6:00 am', 'MM DD YYYY, h:mm a');
// const now = moment();
// const countdown = moment(then - now);
// const days = countdown.format('D');
// const hours = countdown.format('HH');
// const minutes = countdown.format('mm');
// const seconds = countdown.format('ss');



// const VIDEO_MOBILE = "https://media.dojofullstack.com/bootcamp/ads/intro-vls-beta-v-7.mp4";
// const VIDEO_DESKTOP = "https://media.dojofullstack.com/bootcamp/ads/intro-vls-beta-v-7-desktop.mp4";

// const VIDEO_VLS = window.type_device ? VIDEO_MOBILE: VIDEO_DESKTOP;

const VIDEO_POSTER = window.type_device ? "https://media.dojofullstack.com/bootcamp/ads/vlcsnap-2024-10-30-16h36m12s314.png": "https://media.dojofullstack.com/bootcamp/ads/vlcsnap-2024-10-30-16h36m12s314.png";


const VIDEO_MOBILE = "https://media.dojofullstack.com/bootcamp/webinar-oficial-v3.mp4";
const VIDEO_DESKTOP = "https://media.dojofullstack.com/bootcamp/webinar-oficial-v3.mp4";

const VIDEO_VLS = window.type_device ? VIDEO_MOBILE: VIDEO_DESKTOP;

// const Turnos =

// activar estos paises en cloudFront Ojo!!!!!!!!!!!
const KeyCountry = [
    {key: "US", label: "Estados Unidos", countryNumber: "+1"},
    {key: "SG", label: "Singapur", countryNumber: "+65"},
    {key: "AU", label: "Australia", countryNumber: "+61"},
    {key: "GB", label: "Reino Unido", countryNumber: "+44"},
    {key: "CA", label: "Canadá", countryNumber: "+1"},
    {key: "NZ", label: "Nueva Zelanda", countryNumber: "+64"},
    {key: "IE", label: "Irlanda", countryNumber: "+353"}
]

function CarouselContainer(props) {
    const {
      cursor,
      carouselState: { active, dragging },
      ...rest
    } = props;
    let current = -Math.round(cursor) % data.length;
    while (current < 0) {
      current += data.length;
    }
    // Put current card at center
    const translateX =
      (cursor - cardPadCount) * cardSize + (carouselWidth - cardSize) / 2;
    return (
      <NonPassiveTouchTarget
        className={cx("carousel-container", {
          "is-active": active,
          "is-dragging": dragging
        })}
      >
        <NonPassiveTouchTarget
          className="carousel-track"
          style={{ transform: `translate3d(${translateX}px, 0, 0)` }}
          {...rest}
        />

        <div className="carousel-pagination-wrapper">
          <ol className="carousel-pagination">
            {data.map((_, index) => (
              <li key={index} className={current === index ? "current" : ""} />
            ))}
          </ol>
        </div>
      </NonPassiveTouchTarget>
    );
}


function CarouselContainer2(props) {
    const {
      cursor,
      carouselState: { active, dragging },
      ...rest
    } = props;
    let current = -Math.round(cursor) % dataUSA.length;
    while (current < 0) {
      current += dataUSA.length;
    }
    // Put current card at center
    const translateX =
      (cursor - cardPadCount) * 390 + (carouselWidth - 390) / 2;
    return (
      <NonPassiveTouchTarget
        className={cx("carousel-container", {
          "is-active": active,
          "is-dragging": dragging,
        })}
        style={{height: "450px"}}
      >
        <NonPassiveTouchTarget
          className="carousel-track"
          style={{ transform: `translate3d(${translateX}px, 0, 0)` }}
          {...rest}
        />

        <div className="carousel-pagination-wrapper">
          <ol className="carousel-pagination">
            {dataUSA.map((_, index) => (
              <li key={index} className={current === index ? "current" : ""} />
            ))}
          </ol>
        </div>
      </NonPassiveTouchTarget>
    );
  }

const Container = touchWithMouseHOC(CarouselContainer);
const Container2 = touchWithMouseHOC(CarouselContainer2);

// const SlideList = [
//     {
//         textPosition: 'text-center',
//         category: '',
//         title: 'Desarrollo <br/> Web Full Stack Developer a medida y escalable',
//         description: '',
//         buttonText: 'INSCRÍBETE HOY',
//         buttonLink: '#project'
//     }
// ]



const InfoAcordeon = {
    nodejs: "It is ideal for handling high-traffic user and event-driven applications, such as Twitter where hundreds of thousands of tweets are sent every second. Application development is much faster, the apps run better, and users enjoy an enhanced user experience.",
    database: "It's very important to know what, how, and where your data will be stored. Learn the fundamentals from scratch and gain hands-on experience to manage databases professionally. Learn both Relational and Non-Relational databases.",
    web: "In this module, you’ll learn how to create your website starting from a paper prototype. You’ll dive into best practices for web development, working with HTML and CSS. You'll discover tools to optimize your website to the fullest, and implement version control practices with GIT. By the end, you'll know how to apply Bootstrap and Tailwind CSS to your projects.",
    web_deploy: "In this module, you'll master the deployment of complete applications to the cloud: you'll learn how to publish your project on Vercel, Netlify, and AWS Amplify, configure TLD domains, activate SSL certificates, and secure your app in just minutes.",
    js: "In this module, you'll learn the fundamentals of the most widely used programming language today, with which you can create all types of applications. You'll explore its core tools, apply practical cases, and learn development techniques for modern apps using AJAX. By graduation, you'll be able to create interactive web solutions and apply your knowledge to any JavaScript framework.",
    react: "In this third-level Bootcamp module, you’ll learn component-based programming using JavaScript and React, and discover the benefits of data flow management. You'll understand the use of the virtual DOM through React JS development. By the end, you'll be able to create your own SPA applications and work with one of the most popular and advanced frameworks today.",
    python: "Python is one of the most valued and widely used programming languages in the world according to Stack Overflow, the largest developer platform. Many startups and major companies use it daily — including Instagram, Spotify, Amazon, Netflix, Google, Facebook, Dropbox, YouTube, and more. Python is flexible, clear, and easy to read. We’ll also work with the Django framework.",
    git: "Learn all the essential tools to master collaborative programming. You'll learn the foundations and key concepts needed to work on professional projects, whether in a company or as part of a team. This module will equip you with everything necessary to contribute to any developer group.",
    project: "The final project takes place in the fourth month and allows you to validate your learning by building a replica of a real company or startup like MercadoLibre, Instagram, or Airbnb — guided by your mentors. This final project is an amazing tool to add to your portfolio and showcase your work for future job opportunities 😎!",
    deploy_aws: "Amazon Web Services (AWS) is one of the leading cloud computing platforms worldwide. In this Bootcamp, we will deploy the final project using this powerful infrastructure, featuring cutting-edge technology, security, reliability, and scalability.",
    serverless: "Serverless architecture, also known as FaaS (Functions as a Service), enables applications to run in temporary stateless containers. These containers are created when an event triggers the application.",
    api: "In this REST API module with Django, you'll explore the core concepts of REST APIs — including HTTP methods, resources, endpoints, and authentication. You'll learn how to design RESTful APIs following best practices, maintaining consistency, and enabling easy integration with other apps and services.",
    apiSecure: "In this module, you’ll learn to implement automated tests to verify your code works correctly and to identify and fix potential vulnerabilities and security risks in your application. You'll gain the skills needed to ensure your projects are reliable and secure, offering a safe and error-free experience for end users.",
    ciberSeguridad: "In this module, you’ll learn to implement automated tests to verify your code works correctly and to identify and fix potential vulnerabilities and security risks in your application. You'll gain the skills needed to ensure your projects are reliable and secure, offering a safe and error-free experience for end users.",
    appsMobiles: "In this module, you’ll learn how to build cross-platform mobile apps using React Native, allowing you to develop for both iOS and Android from a single codebase. You’ll learn how to use native components, manage app state, and access mobile device features like the camera, location, and push notifications. By the end, you’ll be able to create modern and functional mobile applications tailored to users’ needs.",
    employer: "At DojoFullStack, we believe in the quality of our training and your potential to stand out in the tech industry. That's why, upon completing the Bootcamp, you'll receive personalized 1-on-1 coaching to optimize your profile, prepare for interviews, and craft an effective job search strategy — helping you be fully ready to access real opportunities in the industry."
}


class BootcampEnginierUSA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Temario: "https://media.dojofullstack.com/bootcamp/en-FULLSTACK-2025-dojofullstack-v1.pdf",
            langUS: true,
            isBeca50: false,
            Turnos: [
                {key: "noche", label: "Noche"},
                {key: "dia", label: "Mañana"},
            ],
            bootcampSlug: 'fullstack-us',
            bootcampSlugDescuento: 'fullstack-us',
            bootcampSlugPre: 'fullstack-us',
            bootcampSlug: 'fullstack-us',
            bootcampSlug2: 'fullstack-us',
            IsEspecial24h: false,
            FooterColor: 'linear-gradient(to right, slateblue, rgb(40, 2, 17))',
            FechaEspecial24h: '',
            timestamp24h: "",
            linkPayUSD: "",
            isPricePais: false,
            semibeca_activo: false,
            semibeca_img: "",
            isMount: false,
            beca: '',
            audio: '',
            isPlayed: false,
            pricingAPI: {},
            fecha_start_end: "",
            isPriceEspecial: false,
            PriceEspecialBody: "",
            PriceEspecialPreBody: "",
            timePrueba: "",
            DataFechas: [],
            mesesInicio: [],
            fechaLimite: "",
            showWasapInput: false,
            Eventos: {},
            selectWebinarFecha: 0,
            utc_offset: '-0500',
            Plan: 1,
            formaPago: 1,
            utc_dif: 0,
            select_mes: "",
            select_turno: "",
            select_modalidad: "",
            Email: "",
            Name: "",
            LastName: "",
            Phone: "",
            fechaSelect: "fecha_1",
            isOpenMett: false,
            isOpenSemiBeca: false,
            isOpenSuscribe: false,
            isOpen0: false,
            isOpen: false,
            isOpen2: false,
            isOpen3: false,
            isOpenResume: false,
            isOpenResumeFlex: false,
            countryCode: "US",
            price_cuota: "",
            price_cuota_2: "",
            price_cuota_22: "",
            price_completo: "",
            price_completo_regular: "",
            price_completo_2: "",
            price_completo_regular_2: "",
            price_mensual: "",
            price_preinscripcion: "",
            price_mensual_regular: "",
            titlePrice: "",
            price_ahorro: "",
            descuento: "",
            price_payment: "1",
            salario_fullstack_jr: "$30,000+ USD / Anual",
            salario_fullstack_md: "$50,000+ USD / Anual",
            salario_fullstack_sr: "$30,000+ USD / Anual",
            usa_salario_fullstack_jr: "$30,000+ USD / Anual",
            usa_salario_fullstack_md: "US$ 100,000 ANUAL",
            usa_salario_fullstack_sr: "+USD 140,000 ANUAL",
            isOpenCheckout: false,
            days: 0,
            mes: 1,
            hours: 0,
            minutes: 0,
            seconds: 0,
            enrollMes: "",
            enrollDay: "",
            photoIndex: 0,
            isOpenImg: false,
            MesAcceso: null,
            loadingEnroll: false,
            isCuota: 1 ,
            showMore: false,
            showMoreA: false,
            showMoreB: false,
            showMoreC: false,
            showMoreD: false,
            showMoreE: false,
            showMoreF: false,
            showMoreG: false,
            showMoreI: false,
            showPhoneField: false,
            VideoPitch: false,
            sendDataForm: false,
            isOpenShowPrueba: false,
            agendarActive: false,
            planPagoUSD: "",
            planPagoPE: "",
            isOpenPlanPay: false,
            DescuentoBody: "",
            price_mount: "",
            selectFecha: false,
            DescuentoBodyUSD: "",
            DescuentoBodyPEN: "",
            isOpenReunion: false,
            cuotaDolar: '',
            cuotaSoles: '',
            isOpenModalInfo: false,
            isModalWS: false,
            priceConversion: "",
            garantia: false,
            showButton: true,
            timeCounter: "",
            showDeadLine: false,
            isFlashEspecial: true,
            price_view_base: "",
            porcentajeDescuento: "",
            showWeb: true,
            showWebNow: false,
            showBtnWasi: false,
            showBtnTemario: false,
            showNotifPay: false,
            showPrice: false,
            showBecaParcial: false,
            linkBecaParcial: false,
            linkPayCard: "",
            isOpenBrochure: false,
            fbclid_short_code: "",
            initialOptions: {
                clientId: "AZeHtz9ynRf6LBFEZCIwQcl-wGC6rVlfGKTH44LBcZ9BVs-INyQQ3VpFYAFWAdX2m2GjMhZBmTQ4Dw-C",
                currency: "USD",
                intent: "capture",
                locale: "es_MX",
        }
        };
        this.openModalEmail = this.openModalEmail.bind(this);
        this.openModalWebinar = this.openModalWebinar.bind(this);
        this.openModalCheckout = this.openModalCheckout.bind(this);
        // this.openModalSuscribe = this.openModalSuscribe.bind(this);
        this.openModalVid = this.openModalVid.bind(this);
        this.selectBoot = this.selectBoot.bind(this);
        this.openModal0 = this.openModal0.bind(this);
        this.openModal = this.openModal.bind(this);
        this.openModal2 = this.openModal2.bind(this);
        this.openModal3 = this.openModal3.bind(this);
        this.openModal4 = this.openModal4.bind(this);
        this.openModalPrueba = this.openModalPrueba(this);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitBeca = this.onSubmitBeca.bind(this);
        this.onRenderOption = this.onRenderOption.bind(this);
        this.OpenWS = this.OpenWS.bind(this);
        this.GetLinkWS = this.GetLinkWS.bind(this);
        this.FechaEnroll = this.FechaEnroll.bind(this);
        this.setEmailValidate = this.setEmailValidate.bind(this);
        this.searchEvento = this.searchEvento.bind(this);
        this.DynamicCountry = this.DynamicCountry.bind(this);
        this.fetchPricingData = this.fetchPricingData.bind(this);
    this.getFbclid = this.getFbclid.bind(this);
    this.generarCodigoCorto = this.generarCodigoCorto.bind(this);
    this.eventPing = this.eventPing.bind(this);
    this.generarFBC = this.generarFBC.bind(this);


       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);

    //    window.addEventListener('load', function() {
    //     document.title = 'Desarrollo Web Full Stack Developer Bootcamp | Live | DojoFullStack';
    //     })

    }

 getFbclid() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("fbclid");
  }



  generarCodigoCorto(fbclid) {
    if (!fbclid) return null;
  
    // Simple hash a base36 + slice
    let hash = 0;
    for (let i = 0; i < fbclid.length; i++) {
      hash = fbclid.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    // Convertir hash a base36 y tomar 5 caracteres únicos
    return Math.abs(hash).toString(36).substring(0, 4).toUpperCase();
  }



  generarFBC(fbclid) {
    if (!fbclid) return null;
    const timestamp = Date.now(); // tiempo UNIX en milisegundos
    return `fb.1.${timestamp}.${fbclid}`;
  }


    eventPing(fbclid_short_code, fbclid) {

      if (fbclid){
        const payload = {
          "event_name": "fbclid",
          "fbclid_short_code": fbclid_short_code,
          "fbclid": fbclid
       }
       axios.post("https://api.dojofullstack.com/api/v1/crm/event-fbclid", payload).then((res) => {
        //guardar fbclid_short_code en localstorage
        localStorage.setItem("fbclid_short_code", fbclid_short_code);
       })

      }
    
      };
  

    TrackEventConversion(){
        try {
            window.fbq('track', 'AddToCart', {
                value: 2000,                 // Valor total de la compra
                currency: 'USD',               // Moneda utilizada (ISO 4217)
                content_type: 'product',       // Tipo de contenido
                content_ids: ['bootcamp'],  // ID del producto o identificador
                content_name: 'bootcamp'
            })

            // window.fbq("track", "Contact");
            window.gtag_report_conversion();
        } catch (error) {
            console.log(error);
        }
    }


    getFormattedDate() {
                const date = new Date();
            const day = date.getDate();
            const monthNames = [
                'Enero', 'Febrero', 'Marzo', 'Abril',
                'Mayo', 'Junio', 'Julio', 'Agosto',
                'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();

            return `${day} de ${month} ${year}`;
        }



    DynamicCountry(country='' ){


                this.sleep(1500).then(r => {
                        const timerBar = document.getElementById('counter-deadline');
                        const originalOffset = timerBar.offsetTop;
                        window.addEventListener('scroll', () => {
                            if (window.scrollY > originalOffset) {
                            timerBar.classList.add('sticky');
                            } else {
                            timerBar.classList.remove('sticky');
                            }
                        });
                })



        const isParameterPresent = (param) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.has(param);
        }

        window.urlWasi = this.GetLinkWS();

        const newCountry = country || this.state.countryCode;

        if (country){
            
            const TemarioUSA = 'https://plataforma-dojopy-media.s3.us-east-1.amazonaws.com/FULLSTACK-2025-EN-VIVO-4m-usa_LIVE.pdf';


            this.setState({
              countryCode: country,
              pay_currency_code: "USD",
              initialOptions: {...this.state.initialOptions, locale: `es_${country}`},
          })


            
        }



        function getPaymentParameter(url) {
            // Crear un objeto URL a partir de la cadena de la URL
            const urlObj = new URL(url);
            // Obtener los parámetros de búsqueda
            const params = new URLSearchParams(urlObj.search);
            // Leer el valor del parámetro "payment"
            return params.get('payment') || params.get('pay');
        }


        function getDiscountParameter(url) {
            // Crear un objeto URL a partir de la cadena de la URL
            const urlObj = new URL(url);
            // Obtener los parámetros de búsqueda
            const params = new URLSearchParams(urlObj.search);
            // Leer el valor del parámetro "payment"
            return params.get('discount');
        }

        const discountActive = getDiscountParameter(window.location.href);

        if (discountActive){

            if (discountActive.includes("views")){
                toast.success("Solicita más información sobre el Bootcamp Full Stack Developer en vivo y en línea. ¡Estamos aquí para ayudarte!");
            
                this.sleep(5000).then(r => {
                    const texto = "Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.";
                    window.open(`https://api.whatsapp.com/send?phone=51936670597&text=${texto}`, '_self').focus();
                })


            } else {

                toast.success("¡Obtén ahora mismo un exclusivo código de descuento para el Bootcamp Full Stack Developer online!");
            
                this.sleep(3500).then(r => {
                    const texto = "Hola, tengo un código de descuento para el Bootcamp Full Stack Developer online. #CODE100OFF";
                    window.open(`https://api.whatsapp.com/send?phone=51936670597&text=${texto}`, '_self').focus();
                  })

            }

            
        

        }


        const paymentValue = getPaymentParameter(window.location.href);
        if (paymentValue !== null){
            // console.log(paymentValue);

            if (paymentValue.includes("beca")){
                this.setState({showBecaParcial: true});
            }
            
            const codes = this.state.pricingAPI["redirect"]["codes"];

            if (codes[paymentValue]){
                this.setState({linkBecaParcial: codes[paymentValue]});


                if (!this.state.showNotifPay){
                    toast.success("Un momento por favor, te estamos llevando al sistema de pago.");
                }

                this.sleep(1000).then(r => {
                    window.location.href = codes[paymentValue];
                  })
                  this.setState({showNotifPay: true});

            }
        }


        
        this.setState({
            linkPayUSD: this.state.pricingAPI[this.state.bootcampSlug].linkPayUSD || '',
            select_mes:  this.state.pricingAPI[this.state.bootcampSlug]['fechas'][0]['mes'],
            isPricePais: false,
            utc_offset: '-0500',
            utc_dif: 0,
            timestamp24h: this.state.pricingAPI[this.state.bootcampSlug]['timestamp24h'],
            semibeca_img: this.state.pricingAPI[this.state.bootcampSlug]['semibeca_img'],
            DataFechas: this.state.pricingAPI[this.state.bootcampSlug]['fechas'],
            mesesInicio: this.state.pricingAPI[this.state.bootcampSlug]['mesesInicio'],
            Turnos: this.state.pricingAPI[this.state.bootcampSlug]['turnos'],
            fechaLimite: this.state.pricingAPI[this.state.bootcampSlug]['fechaLimite'],
            isPriceEspecial: this.state.pricingAPI[this.state.bootcampSlug]['isPriceEspecial'],
            PriceEspecialBody: this.state.pricingAPI[this.state.bootcampSlug]['PriceEspecialBody'],
            PriceEspecialPreBody: this.state.pricingAPI[this.state.bootcampSlug]['PriceEspecialBody'],
            timePrueba: this.state.pricingAPI[this.state.bootcampSlug]['time_prueba'],
            FooterColor: this.state.pricingAPI[this.state.bootcampSlug]['FooterColor'],
            price_completo: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base'], //495
            price_completo_regular: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base_regular'],
            price_mensual: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_final'],
            price_mensual_regular: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base_regular'],
            titlePrice: this.state.pricingAPI[this.state.bootcampSlug]['titlePrice'],
            titlePricePre: this.state.pricingAPI[this.state.bootcampSlug]['titlePrice'],
            price_payment: "1",
            planPagoUSD: this.state.pricingAPI[this.state.bootcampSlug]['planPagoUSD'],
            planPagoPE: this.state.pricingAPI[this.state.bootcampSlug]['planPagoPE'],
            DescuentoBody: this.state.pricingAPI[this.state.bootcampSlug]['DescuentoBody'],
            price_mount: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['mount'],
            DescuentoBodyUSD: this.state.pricingAPI[this.state.bootcampSlug]['DescuentoBodyUSD'],
            DescuentoBodyPEN: this.state.pricingAPI[this.state.bootcampSlug]['DescuentoBodyPEN'],
            cuotaDolar: this.state.pricingAPI[this.state.bootcampSlug]['cuotaDolar'],
            cuotaSoles: this.state.pricingAPI[this.state.bootcampSlug]['cuotaSoles'],
            priceConversion: this.state.pricingAPI[this.state.bootcampSlug]["priceConversion"] || '',
            garantia: this.state.pricingAPI[this.state.bootcampSlug]["garantia"] || false,
            porcentajeDescuento: this.state.pricingAPI[this.state.bootcampSlug]?.porcentajeDescuento || '',
            fecha_inicio: this.state.pricingAPI[this.state.bootcampSlug]["fecha_inicio"] || false,
            redirect: this.state.pricingAPI["redirect"] || false,
            price_completo_2: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base'], //495
            price_completo_regular_2: this.state.pricingAPI[this.state.bootcampSlug]['price']['usd']['price_view_base_regular'],
        })

        

        try {
            if (this.state.pricingAPI[this.state.bootcampSlug].price[country]){
                this.setState({
                    isPricePais: true,
                    price_completo: this.state.pricingAPI[this.state.bootcampSlug].price[country].price_view_base,
                    price_completo_regular: this.state.pricingAPI[this.state.bootcampSlug].price[country].price_view_base_regular,
                    price_completo_2: this.state.pricingAPI[this.state.bootcampSlug]['price'][country]['price_view_base'],
                    price_completo_regular_2: this.state.pricingAPI[this.state.bootcampSlug]['price'][country]['price_view_base_regular']
                });

                if (country === 'PE') {
                    this.setState({linkPayUSD: this.state.pricingAPI[this.state.bootcampSlug].linkPayPeru || this.state.pricingAPI[this.state.bootcampSlug].linkPayUSD});
                }
            }
        } catch (error) {
            console.log('Log',error);
        }



        if (newCountry === 'PE') {
            this.setState({
                utc_offset: '-0500',
            });
        } else if (newCountry === 'MX') {
            this.setState({
                utc_dif: -1,
                utc_offset: '-0600',
                });
        } else if (newCountry === 'CR'){
            this.setState({utc_dif: -1, utc_offset: '-0600'});
        } else if (newCountry === 'CL'){
            this.setState({utc_dif: -1, utc_offset: '-0400'});
        } else if (newCountry === 'BO'){
            this.setState({
                utc_dif: -1,
                utc_offset: '-0400',
                });
        } else if (newCountry === 'CU'){
            this.setState({utc_dif: +1});
        } else if (newCountry === 'SV'){
            this.setState({utc_dif: -1, utc_offset: '-0600'});
        } else if (newCountry === 'GT'){
            this.setState({utc_dif: -1});
        } else if (newCountry === 'HN'){
            this.setState({utc_dif: -1, utc_offset: '-0600'});
        } else if (newCountry === 'NI'){
            this.setState({utc_dif: -1});
        } else if (newCountry === 'PY'){
            this.setState({utc_dif: +1, utc_offset: '-0300'});
        } else if (newCountry === 'PR'){
            this.setState({utc_dif: +1, utc_offset: '-0300'});
        } else if (newCountry === 'DO'){
            this.setState({utc_dif: +1});
        } else if (newCountry === 'UY'){
            this.setState({
                utc_dif: +2,
                utc_offset: '-0300'
            });
        } else if (newCountry === 'BR'){
            this.setState({
                utc_dif: +2,
                utc_offset: '-0300'
            });
        }

        if (newCountry === 'ES') {
            this.setState({
                utc_offset: '+0100',
            });
        }

    }


    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    OpenMeet(){
        if (this.state.Phone){
            window.open(`https://calendly.com/dojopy/bootcamp-fullstack?name=${this.state.Name}&email=${this.state.Email}&phone=${this.state.Phone}`, '_blank').focus();
        } else {
            window.open("https://calendly.com/dojopy/bootcamp-fullstack", '_blank').focus();
        }
    }


    GetLinkWS(){
        let texto = "Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.";
 
        if (window.type_device){
            return `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        } else {
            return `https://web.whatsapp.com/send?phone=51936670597&text=${texto}`;
        }
    }

    GetLinkWSReunion(){
        let texto = "Hola, me gustaría agendar una reunión informativa sobre el bootcamp Full Stack Developer.";
    
        if (window.type_device){
            return `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        } else {
            return `https://web.whatsapp.com/send?phone=51936670597&text=${texto}`;
        }
    }

    OpenWS(){
        const body = this.GetLinkWS();
        window.open(body, '_blank').focus();
        fbq("track", "contact");
    }

  onRenderOption(option, complete) {
    return (
      <li>
        <ReactCountryFlag
          countryCode={option.key}
          svg
          style={{
            width: "2em",
            height: "2em",
            padding: "1px",
          }}
          title="país"
        />{" "}
        {complete ? option.countryNumber : option.key}
      </li>
    );
  }



  onRenderSelection( selected, settings, deselect ){
    return 	(<span style={{ marginRight: 10, padding: 5 }}>
{ selected ?
        <span style={{"color": "#1f1f25"}}>
            <ReactCountryFlag
            countryCode={selected.key}
            svg
            style={{
                width: '2.3em',
                height: '2.3em',
                padding: '7px'
            }}
            title="país"
    />  {selected.countryNumber}
        </span>
        :
           <span style={{padding: 5}}>País</span>
    }
    
<i style={{ paddingLeft: 5, cursor: "pointer" }} onClick={ deselect } className="fa fa-window-close"></i>
</span>)
}


    FechaEnroll(e){
        let fecha_enroll = e.currentTarget.value;
        this.setState({fechaSelect: fecha_enroll});


        window.location.href = '#fechas';
    }


    onSubmit(e, brochure=false) {
        e.preventDefault();
        
        
        if (this.state.Email.trim() === "" || !this.state.Email.trim().includes("@") ) {
            toast.dark('Oops! The Email field is required to continue.');
            return;
        }

        if (this.state.Phone.trim() === "") {
            toast.dark('Oops! The Phone Number field is required to continue.');
            return;
          }
  
        this.setState({loadingEnroll: true, sendDataForm: true});

          window.fbq('track', 'Lead', {
            content_name: 'Registro formulario Bootcamp',
            content_category: 'Full Stack Developer Online'
          });

        
        toast.success(`Hi ${this.state.Name}! ✅ You'll soon receive all the program details via email and phone. Feel free to message us if you have any questions! 💬`);


        const timer = setTimeout(() => {
             this.setState({isOpenBrochure: false, isOpenSuscribe: false, isOpenMett: false, isOpenModalInfo : false, selectFecha: false, loadingEnroll: false});
            window.open(this.state.Temario, '_blank').focus();
        }, 1000); // 3 segundos


        //   ttq.track('CompleteRegistration', {
        //     content_name: 'Registro formulario Bootcamp',
        //     content_category: 'Full Stack Developer Online'
        //   });


//                     toast.success(
//   `¡Hola ${this.state.Name}! 📥 Tu brochure se está descargando.  
// Si necesitas ayuda, escríbenos por WhatsApp.`
// );

// if (brochure){
//         // enviar brochure por email
//         const timer = setTimeout(() => {
//              this.setState({isOpenBrochure: false, isOpenSuscribe: false, isOpenMett: false, isOpenModalInfo : false, selectFecha: false, loadingEnroll: false});
//             toast.success(`¡Hola ${this.state.Name}! 📩 Te enviamos el brochure por email y WhatsApp. Si tienes dudas, estamos a un mensaje de distancia 💬`);
//             window.open(this.state.Temario, '_blank').focus();
//         }, 1500); // 3 segundos
        
// }

// toast.success(`¡Hola ${this.state.Name}! 🎉 Tu solicitud de beca parcial ha sido recibida. Te contactaremos en las próximas 24 horas para confirmar si calificas. ¡Revisa tu email y WhatsApp! 📩💬`);


        localStorage.setItem('email', this.state.Email.trim());
        localStorage.setItem('phone', this.state.Phone.trim());

        if (this.state.Name.trim()){
            localStorage.setItem('name', this.state.Name.trim());
        }

        // const source = window.location.search.split('source=')[1] || 'home';

        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {evento: false, lead: true, bootcamp: 'Web Full Stack Developer', email: this.state.Email, name: this.state.Name, country: this.state.countryCode,
            Token: "c3b4b89c",
            landing: 'home',
            source: window.location.search,
            phone: this.state.Phone
    },)
        .then(res => {




//             toast.success(
//   `¡Hola ${this.state.Name}! 🎉 Tu inscripción está casi lista. Ahora serás redirigido al pago para asegurar tu plaza. 
// Si necesitas ayuda, escríbenos por WhatsApp.`
// );


            this.setState({isOpenSuscribe: false, isModalWS: false, isOpenMett: false, isOpenModalInfo : false, selectFecha: false, loadingEnroll: false});
            // window.fbq("track", "Contact");
            // window.gtagSendEvent();
            // this.setState({isModalWS: true})
            // const timer = setTimeout(() => {
            //     const link = this.GetLinkWS();
            //     window.open(link, '_blank').focus();
            // }, 5000); // 3 segundos

            window.fbq('track', 'AddToCart', {
                value: 2000,                 // Valor total de la compra
                currency: 'USD',               // Moneda utilizada (ISO 4217)
                content_type: 'product',       // Tipo de contenido
                content_ids: ['bootcamp'],  // ID del producto o identificador
                content_name: 'bootcamp'
              });

     
            //   document.querySelector('#fechas').scrollIntoView({ behavior: 'smooth' });
              

            // window.open(`https://media.dojofullstack.com/bootcamp/FULLSTACK-2025-dojofullstack-v17.pdf`, '_blank').focus();

            // window.Calendly.initPopupWidget({url: `https://calendly.com/dojofullstack/agendar?hide_event_type_details=1&hide_gdpr_banner=1&email=${this.state.Email}&name=${this.state.Name}`})

        })
    }




    onSubmitBeca(e) {
        e.preventDefault();
        if(this.state.Email === "" ){
            toast.warning('¡Ups! El campo de Email es necesario para continuar.');
            return;
        }
        // if(this.state.Phone === "" ){
        //     toast.warning('El campo WhatsApp es requerido, para ser atendido por un asesor.');
        //     return;
        // }
        this.setState({loadingEnroll: true, sendDataForm: true});

        localStorage.setItem('email', this.state.Email);
        localStorage.setItem('phone', this.state.Phone);

        // toast.success(`${this.state.Name} enviamos tus datos al equipo de Dojopy, gracias!`);
        // let cupon = window.location.search.split('ref=')[1];
        this.setState({isOpenSuscribe : false, isOpenSemiBeca: false, isOpenMett: false, loadingEnroll: false});

        axios.post('https://cprij4toee.execute-api.us-east-1.amazonaws.com/dev',
        {beca: true , lead: true, bootcamp: 'Web Full Stack Developer', email: this.state.Email, name: this.state.Name, phone: this.state.Phone, country: this.state.countryCode, fecha: this.state.selectWebinarFecha},)
        .then(res => {
            window.gtag_report_conversion();


            toast.success(`Hola!, "¡Gracias por aplicar! Hemos recibido tu solicitud y estamos emocionados de brindarte un descuento adicional. Nuestro equipo revisará tu solicitud y te enviaremos un código de descuento único en un plazo de 24 horas. ¡No olvides revisar tu bandeja de entrada! Si tienes alguna pregunta, no dudes en contactarnos. "`);
            // toast.success(`Hola ${this.state.Name}!, tengamos una breve sesión informativa para completar tu inscripción`);

        })
    }



    searchEvento(myArray, key){
        for (let i=0; i < myArray.length; i++) {
            if (myArray[i].key === key) {
                return myArray[i].value;
            }
        }
    }

    
    sendEventAddCart(){
        window.fbq('track', 'AddToCart', {
            value: 2000,                 // Valor total de la compra
            currency: 'USD',               // Moneda utilizada (ISO 4217)
            content_type: 'product',       // Tipo de contenido
            content_ids: ['bootcamp'],  // ID del producto o identificador
            content_name: 'bootcamp'
          });
    }



renderCard(index, modIndex) {
    const item = data[modIndex];
    return (
        <div
        key={index}
        className="carousel-card"
        >
        <div
            className="carousel-card-inner"
            style={{backgroundImage: item.background , backgroundSize: "cover"}}
        >
            {item.title}
        </div>
        </div>
    );
    }

renderCard2(index, modIndex) {
    const item = dataUSA[modIndex];
    return (
        <div
        key={index}
        className="carousel-card mx-2"
        >
        <div style={{width: "295px"}}>
           <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "19px", "background": "white"}}>
                <h4>
                {item.title}
                </h4>
                {/* agreg una imagen con un boxshadow suave genial */}
                <img style={{borderRadius: "33px", boxShadow: "0 4px 24px 0 rgba(140, 82, 255, 0.18), 0 1.5px 6px 0 rgba(44, 62, 80, 0.10)" }} alt={item.title} height="199px" src={item.background} />
            </div>
        </div>
        </div>
    );
    }


renderBeca() {
    return (
        <>

 {/* Start PRicing Table Area  */}
 <div className="col-12 mt-1" style={{paddingBottom: "13px", paddingRight: "15px", paddingLeft: "15px", maxWidth: "470px", marginRight: window.type_device ? "auto": "1px" }} >


<div className="rn-pricing" style={{boxShadow: "rgba(140, 82, 255, 0.9) 4px 4px 15px 3px", border: "none", background: "linear-gradient(135deg, #C56CD6 0%,#3425AF 100%)", borderRadius: "20px"}} >
    <div className="pricing-table-inner">

        <div className="pricing-header pb-0 mb-2 mt-1">
  
        
        <span style={{padding: "6px 10px", margin: "5px", "background-color": "tomato", "border-radius": "7px", "color": "white", "font-size": "20px", fontWeight: "bold"}}>
                {this.state.countryCode === 'PE' ? this.state.DescuentoBodyPEN: this.state.DescuentoBodyUSD}
        </span>


        <h3 className="text-white mt-1 mb-0">Monto Total con la Beca50</h3>
             
            <span style={{color: "white", display: "inline-block"}}>
                <del style={{color: "lightgray", fontSize: "25px"}}>
                &nbsp; {this.state.price_completo_regular} &nbsp;
                </del>
            </span>


            <h3 className="pricing" style={{marginBottom: "5px"}} >
            <span style={{color: "white", fontSize: "18px"}}>Ahora: </span>

            {this.renderPrice(this.state.price_completo)}
            </h3>


         

            <div className="slide-btn" style={{marginTop: "15px", textAlign: "center"}}>
                <a href="#empezar" >
                <button
                    onClick={() => {
                    window.fbq('track', 'AddToCart', {
                        value: 2000,// Valor total de la compra
                        currency: 'USD',               // Moneda utilizada (ISO 4217)
                        content_type: 'product',       // Tipo de contenido
                        content_ids: ['bootcamp'],  // ID del producto o identificador
                        content_name: 'bootcamp'
                      });
                }}
                id="enroll_bootcamp_2"
                style={{border: "1px solid white", lineHeight: "28px", fontSize: "23px", marginBottom: "13px", padding: "15px 20px" }}
                className=" btn-efect">
                    <HiMiniPencilSquare className="mr-1" />

                Inscríbete Ahora

                 </button>
                </a>
             </div>



        </div>
    </div>


    


</div>
</div>
{/* End PRicing Table Area  */}


        </>
    )
}


renderPais(complete=false){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} > {true ? "Zona horaria:": "Time zone:"} </span>
            <Selectrix
        height={300}
        onRenderOption={(option) => this.onRenderOption(option, complete)}
        onRenderSelection={(option) => this.onRenderSelection(option, complete)}
        placeHolderInside={true}
        placeholder={"País"}
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.countryCode}
        options={KeyCountry}
        onChange={value => {
            // if (value.key === 'US'){ window.location.href = '/us'}
            this.DynamicCountry(value.key)}
        }
    />
        </>

    )
}




renderMes(){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} > {true ? "Mes:": "Month:"} </span>
        <Selectrix
        height={250}
        placeHolderInside={true}
        placeholder={true ? "Todos": "All" }
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.select_mes}
        options={this.state.mesesInicio.map((item) => ({key: item, label: item})) }
        onChange={value => this.setState({select_mes: value.key})}
    />
        </>

    )
}

renderTurno(){
    return (
        <>
        <span style={{
            fontSize: "17px",
            fontWeight: "bold",
            position: "absolute",
            left: "15px",
            top: "-25px",
            zIndex: "1",
        }} >{true ? "Turno": "Shift"}:</span>
        <Selectrix
        height={250}
        placeHolderInside={true}
        placeholder={true ? "Todos": "All" }
        customScrollbar={true}
        searchable={false}
        materialize={false}
        defaultValue={this.state.select_turno}
        options={this.state.Turnos}
        onChange={value => this.setState({select_turno: value.key})}
    />
        </>

    )
}


renderPrice(price,  prueba=false){
        return (
            <>
                <div className="row" style={{placeContent: "center", fontFamily: "'Poppins',sans-serif"}}>
                <div className="col-12">

                    <p style={{marginTop: '5px', fontFamily: "'Poppins',sans-serif", fontSize: window.type_device ? '39px': '45px', "color": prueba ? "#B8860B": "white", fontWeight: "bold", paddingTop: "7px", paddingBottom: "7px"}}>
                         {price} 
                    </p>
                </div>
                </div>
           
            </>
        )
}


renderInfoBootcamp(){
    return (
        <div>

        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Acceso inmediato a clases en vivo y plataforma 100 % práctica.
        </p>
        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Proyectos reales + Mentorías 1:1 con expertos en Frontend, Backend y DevOps.
        </p>

        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Plan de estudios completo: HTML, CSS, JavaScript, Python, AWS y más.
        </p>
    
        <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Preparación Laboral Real y bolsa de vacantes exclusiva.
        </p>
          <p style={{marginBottom: window.type_device ? "7px": "12px", fontSize: "16px"}}>
        <span style={{"color":"slateblue", "fontSize": "25px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
        Modalidades flexibles: en vivo y Asíncrono a tu ritmo.
        </p>
     

        </div>
    )
}

renderPriceFooter(price){
        return (
            <>
                <span style={{fontSize: "17px", "color": "white", fontWeight: 500, paddingTop: "5px", paddingBottom: "5px"}}>
                    2 pagos de {price}
                </span>
                <ReactCountryFlag
                        countryCode={this.state.countryCode}
                        svg
                        style={{
                            width: '3.5em',
                            height: '3.5em',
                            padding: '9px'
                        }}
                        title="país"
                    />
            </>
        )
      }

      renderHorario(){
            if (this.state.countryCode === "PE" || this.state.countryCode === "EC" || this.state.countryCode === "CO") {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">
                    <ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" /> 7:00 PM a 09:00 PM</p>
            } else if (this.state.countryCode === "MX" || this.state.countryCode === "HN" || this.state.countryCode === "CR") {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" />6:00 PM a 08:00 PM</p>
            } else if (this.state.countryCode === "BO") {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" />8:00 PM a 10:00 PM</p>
            }  else {
                return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '1.8em',
                    height: '1.8em',
                    padding: '1px'
                }} title="país" />7:00 PM a 09:00 PM</p>
            }
      }

      renderHorarioFinSemana(){
        if (this.state.utc_offset === "-0500") {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else if (this.state.utc_offset === "-0600"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else if (this.state.utc_offset === "-0400"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else if (this.state.utc_offset === "+0100"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        } else {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1"><ReactCountryFlag
                countryCode={this.state.countryCode}
                svg
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    padding: '8px'
                }} title="país" />10:00 AM a 12:00M</p>
        }

    }

    renderHorarioFinSemanaTarde(){
        if (this.state.utc_offset === "-0500") {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">03:00 PM a 05:30 PM</p>
        } else if (this.state.utc_offset === "-0600"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">02:00 PM a 04:35 PM</p>
        } else if (this.state.utc_offset === "-0400"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">04:00 PM a 06:35 PM</p>
        } else if (this.state.utc_offset === "+0100"){
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">09:00 PM a 11:35 PM</p>
        } else {
            return  <p style={{fontSize: "17px", fontWeight: 500}} className="mb-1">03:00 PM a 05:35 PM</p>
        }
    }


    obtenerDiaActual() {
        try {
            const diasDeLaSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
            const fechaActual = new Date();
            const diaActual = fechaActual.getDay(); // Obtiene el índice del día (0=domingo, 1=lunes, etc.)
            return diasDeLaSemana[diaActual]; // Devuelve el día correspondiente en texto
        } catch (error) {
            return ""
        }
    }


    renderFechaSelect(item, key){
        return (
            <div key={key} className="row row--35 align-items-center rn-address py-3" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">
                <h2 style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                             <FaCalendarWeek className="mr-1" />  {this.state.fecha_inicio}

                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                
           
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-12  my-0">
                     <span style={{padding: "3px", marginLeft: "8px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                <span className="pulsar"></span> {!this.state.langUS ? "Live": "Live"}
                        </span>
                    </div>
               
                </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2" ><b> {true ? "Duración": "Duration"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> Duración: 4 months
                <span style={{display: "inline-block"}}></span>
                </p> </div>
           
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none", borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2"><b> {true ? "Days": "Days"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> {item.dias} </p> </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: "none"}}>
            <div> <h5 className="mb-2">
                <b>
                Horario
                 {item.turno === 'dia' &&  <> (Mañana) <BsSun style={{height: "25px", width: "25px", color: "goldenrod", marginLeft: "3px", fontSize: "23px"}}/>  </>  }
                 {item.turno === 'tarde' && <> (Tarde) <BsCloudSunFill style={{height: "25px", width: "25px", color: "darkblue", marginLeft: "3px", fontSize: "23px"}} /> </>  }
                 {item.turno === 'noche' && <> (Noche) <MdModeNight style={{height: "25px", width: "25px", color: "darkblue", marginLeft: "3px", fontSize: "23px"}} /> </>   }
                </b>
                </h5> </div>
                <div className="row">
                    <div className="col-12">

                    {(item.turno == 'noche' || item.turno == 'night') && this.renderHorario() }
                    {item.turno == 'dia'  && this.renderHorarioFinSemana() }
                    {item.turno == 'tarde'  && this.renderHorarioFinSemanaTarde() }
                    </div>

                </div>
            </div>
            


<div className="col-12" style={{boxShadow: "none", padding: "8px"}}>
<a href={`#empezar`} >
<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >


    Solicitar mi beca parcial

</button>
</a>


</div>










        </div>
        )
      }


      renderFechas() {
        return (
            <div>

   <div className="row row--35 align-items-center rn-address py-3 mb-2 mb-5" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">

                     <div className="row" style={{justifyContent: "space-between", alignItems: "center"}}>
                            <div className="">
                                <span style={{fontWeight: "bold", display: "inline-block", padding: "0.5rem 1rem", marginLeft: "7px", "background-color": "tomato", "border-radius": "33px", "color": "white", "font-size": "18px"}}>
                                    <span className="pulsar mr-1"></span> {!this.state.langUS ? "Live": "Live"}
                                </span>
                              </div>

                            <div className=" my-0">
                                 <span className="px-1" style={{fontWeight: "normal", fontSize: "15px", color: "#6b7280"}}>
                                  Next start
                                  </span>
                            </div>
                    </div>

                <h2 className="mt-2" style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                    {this.state.fecha_inicio}
                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                       <p className="my-0" style={{fontSize: "16px", color: "#6b7280"}}>
                  Direct interaction and personalized feedback
                </p>
           
        
            </div>

      

            <div className="col-md-6 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none"}}>
                     <div> <p style={{fontSize: "16px"}}>
                    <FaCalendarWeek className="mr-1" /> <b> {this.state.fecha_inicio} </b>  - Start Date
                <span style={{display: "inline-block"}}></span>
                </p> </div>
                
                 <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" /> 
                  <b> ⏰ 7:00 PM - 9:00 PM</b> <ReactCountryFlag countryCode={this.state.countryCode} svg style={{
                                                                                                            width: '2.3em',
                                                                                                            height: '2.3em',
                                                                                                            padding: '7px'
                                                                                                        }} title="país"/>
                    </p>
                    </div>

                     <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" /> 
<b>  4 months </b> <br/>
Monday and Wednesday 
                    </p>
                    </div>

           <div>
            <p style={{fontSize: "16px"}}> 
         <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Lifetime access, no time or location limits.
           </p>
           </div>

            <div> <p style={{fontSize: "16px"}}> 
         <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Available 24/7 on all devices
           </p>
           </div>
            <div> <p style={{fontSize: "16px"}}> 
         <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Downloadable resources and materials
           </p>
           </div>
           
           <div> <p style={{fontSize: "16px"}}> 
         <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Access to exclusive community
           </p>
           </div>

           <div> <p style={{fontSize: "16px"}}> 
         <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Professional support and mentoring.
           </p>
           </div>
           
            <div> <p style={{fontSize: "16px"}}>
         <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Official completion certificate
           </p>
           </div>
            </div>



<div className="col-12 mt-1" style={{boxShadow: "none", padding: "8px"}}>
<a href={`/en/enroll/${this.state.bootcampSlug}/${this.state.countryCode}`}>

<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >

                    Reserve spot

</button>
</a>


</div>


        </div>

{/* 
     <div className="row row--35 align-items-center rn-address py-3 mb-2" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">

                     <div className="row" style={{justifyContent: "space-between", alignItems: "center"}}>
                            <div className="">
                                <span style={{fontWeight: "bold", display: "inline-block", padding: "0.5rem 1rem", marginLeft: "7px", "background-color": "#d1fae5", "border-radius": "33px", "color": "#065f46", "font-size": "18px"}}>
                                  <MdOutlineVideoLabel className="mr-1" />  Asíncrono
                                </span>
                              </div>

                            <div className=" my-0">
                                 <span className="px-1" style={{fontWeight: "normal", fontSize: "15px", color: "#6b7280"}}>
                                   Acceso inmediato
                                  </span>
                            </div>
                    </div>
                    

                <h2 className="mt-2" style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                    Modalidad A Tu Ritmo
                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                       <p className="my-0" style={{fontSize: "16px", color: "#6b7280"}}>
                    Aprende cuando quieras, donde quieras
                </p>
           
        
            </div>

        

            <div className="col-md-6 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none"}}>
                   <div> <p style={{fontSize: "16px"}}> <MdWatchLater style={{fontSize: "23px"}}  className="mr-1" />  <b>180 horas </b> 
                de contenido y recursos.
                <span style={{display: "inline-block"}}></span>
                </p> </div>

                <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Accede de por vida, sin límites de tiempo ni lugar.
                    </p>
                    </div>
                        <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Disponible 24/7 en todos los dispositivos
                    </p>
                    </div>
                         <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Recursos y materiales descargables
                    </p>
                    </div>
                    
                    <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Acceso a comunidad exclusiva
                    </p>
                    </div>

                    <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Soporte profesional y mentorías.
                    </p>
                    </div>
                    
                         <div> <p style={{fontSize: "16px"}}> 
                  <FaCheckCircle style={{fontSize: "19px"}} className="mr-1" />  Certificado oficial de finalización
                    </p>
                    </div>
            </div>



<div className="col-12 mt-1" style={{boxShadow: "none", padding: "8px"}}>
<a href={`/en/enroll/${this.state.bootcampSlug}/${this.state.countryCode}`}>

<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >

                    Comenzar ahora
</button>
</a>


</div>


        </div> */}







      {/* <div className="row row--35 align-items-center rn-address py-3" data-aos="fade-up"  style={{boxShadow: "#c6c9d8 8px 6px 15px 10px"}} >
            <div className="col-12 mb-1">
                <h2 style={{marginBottom: "0px", fontSize: window.type_device && "27px" }}>
                             <FaCalendarWeek className="mr-1" />  {this.state.fecha_inicio}

                </h2>

                <div style={{width: window.type_device ? "200px": "450px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "20px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                
           
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-12  my-0">
                     <span style={{padding: "3px", marginLeft: "8px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                <span className="pulsar"></span> {!this.state.langUS ? "Live": "Live"}
                        </span>
                    </div>
               
                </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2" ><b> {true ? "Duración": "Duration"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> 4 months
                <span style={{display: "inline-block"}}></span>
                </p> </div>
           
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: window.type_device ? "3px": "none", borderRight: !window.type_device ? "1px solid #121212" : "none" }}>
                <div> <h5 className="mb-2"><b> {true ? "Days": "Days"} </b></h5> </div>
                <div> <p style={{fontSize: "17px"}}> Martes y Jueves </p> </div>
            </div>

            <div className="col-md-3 col-12 mt-2" style={{marginTop: "none"}}>
            <div> <h5 className="mb-2">
                <b>
                Horario
                 {true && <> (Noche) <MdModeNight style={{height: "25px", width: "25px", color: "darkblue", marginLeft: "3px", fontSize: "23px"}} /> </>   }
                </b>
                </h5> </div>
                <div className="row">
                    <div className="col-12">

                    { this.renderHorario() }
                    </div>

                </div>
            </div>
            


<div className="col-12" style={{boxShadow: "none", padding: "8px"}}>
<a href={`#empezar`} >
<button onClick={this.sendEventAddCart} className="btn-efect-2" style={{border: "1px solid white", padding: "10px 25px", fontSize: '23px', textTransform: "none", fontFamily: "Poppins, sans-serif"}} >


    Continuar

</button>
</a>


</div>






        </div> */}

       
          </div>

        )}


    selectBoot(plan){
        this.setState({Plan: plan});
        window.location.href='#enroll';
    }

    openModalVid (){
        this.setState({isOpenVid: !this.state.isOpenVid});
    }
    openModal0 () {
        this.setState({isOpen0: !this.state.isOpen0});
    }
    openModalEmail (){
        this.setState({isOpenMett: !this.state.isOpenMett});
    }

    openModalWebinar (){
        this.setState({isOpenSuscribe: true});
    }

    openModalCheckout (){
        this.setState({isOpenCheckout: !this.state.isOpenCheckout});
        this.setState({price_payment: "1"});
        // if (type_bootcamp === 1){
        //     this.setState({price_payment: "95"});
        // } else {
        //     this.setState({price_payment: "175"});
        // }

    }

    // openModalSuscribe (e){
    //     // window.location.href = "/Inscripcion";
    //     // if (e){
    //     //     this.setState({fechaSelect: e.target.value});
    //     // }
    //     this.setState({isOpenSuscribe: !this.state.isOpenSuscribe});
    // }

    openModal () {
        this.setState({isOpen: !this.state.isOpen});
    }

    openModal2 () {
        this.setState({isOpen2: !this.state.isOpen2});
    }
    openModal3 () {
        this.setState({isOpen3: !this.state.isOpen3});
    }
    openModal4(){
        this.setState({isOpenResume: !this.state.isOpenResume});
    }

    openModalPrueba(){
        this.setState({isOpenShowPrueba: !this.state.isOpenShowPrueba});
    }

    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open');
    }
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }
    stickyHeader () {}


    validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

    setEmailValidate (email){
        this.setState({ Email: email});
        if (this.validateEmail(email)){
            this.setState({showPhoneField: true});
        }
    }



    render(){
        // const PostList = BlogContent.slice(0 , 5);

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }

        const style = {
            marginTop: '12px',
            color: '#2F2F2F',
            border: '2px solid #2F2F2F'
          };

          const TypingAnimation =  React.memo(()=>{
            return true ?
            <Typical
            className={'my-tipical'}
            steps={['Become a Full Stack Developer in just 4 months', 500, 'and access high-demand tech jobs.']}
            loop={true}
            wrapper="h2"
                />:
                <Typical
                className={'my-tipical'}
                steps={['Create Full Stack Developer Platforms', 500, 'Get your dream job.', 500, 'The best Full Stack Developer Bootcamp in 5 months.']}
                loop={true}
                wrapper="h2"
                />
          },(props,prevProp)=> true ); // this line prevent re rendering

          const TypingAnimation2 =  ()=> {
            return <Typical
            steps={['Learn online', 500 ,'With guidance from your mentor.', 1000]}
            loop={Infinity}
            wrapper="h2"/>
          }; // this line prevent re rendering

        
          const ButonsFechas = () => {
            return (
                <div data-aos="fade-right" className="col-12 col-md-6"
                style={{marginBottom: "10px",
                      paddingLeft: window.type_device ? "5px": "50px",
                       paddingRight: window.type_device ? "5px": "50px"}}
              >
                  <div style={{textAlign: "center", padding: "5px", borderRadius: "20px"}}>

           
             


                    {FECHAS_EVENTO.map((fecha, index) => (
                            <div className="my-3" key={index} >
                            <button  onClick={() => this.setState({selectFecha: true})}  className="btn-efect" style={{width: "100%", boxShadow: "2px 2px 5px 1px rgba(140, 82, 255, 0.9)"}}>
                                {fecha}
                            </button>
                            </div>
                    ))}
                

                  {/* <div className="my-3" >
                  <button  onClick={() => this.setState({selectFecha: true})}  className="btn-efect" style={{width: "100%"}}>
                    Viernes, 8 de diciembre, 7:00 PM
                  </button>
                  </div>

                  <div className="my-3" >
                  <button  onClick={() => this.setState({selectFecha: true})}  className="btn-efect" style={{width: "100%"}}>
                  Sábado, 9 de diciembre, 12:00M
                  </button>
                  </div> */}

                  </div>
      </div>
            )
          }


        return (
            <Fragment>

                <Helmet>
                    <title>
                        {true ? "Bootcamp Full Stack Developer | Live | DojoFullStack": "Full Stack Developer Bootcamp | 100% live online | DojoFullStack"}
                           </title>
                    <meta name="description"
                    content="Become a Full Stack Developer in our 4-month live online Bootcamp, master Frontend and Backend web development using HTML, CSS, JavaScript, React, Python and AWS, receive the Employability Program upon completion. Create real projects and learn best programming practices at DojoFullStack!"
                    />
                    <meta
                        property="og:description"
                    content="Become a Full Stack Developer in our 4-month live online Bootcamp, master Frontend and Backend web development using HTML, CSS, JavaScript, React, Python and AWS, receive the Employability Program upon completion. Create real projects and learn best programming practices at DojoFullStack!"
                        />
                   <meta
                        name="twitter:description"
                    content="Become a Full Stack Developer in our 4-month live online Bootcamp, master Frontend and Backend web development using HTML, CSS, JavaScript, React, Python and AWS, receive the Employability Program upon completion. Create real projects and learn best programming practices at DojoFullStack!"
                    />
                </Helmet>

                {/* Start Header Area  */}
                <Header callbackOpenModal={() => this.setState({isOpenMett: true}) } bootcampSlug={this.state.bootcampSlug}  langUS={true}  langES={this.state.countryCode === 'ES' ? true : false}  countryCode={this.state.countryCode} DynamicCountry={this.DynamicCountry} />
                {/* End Header Area  */}



                {/* Start Slider Area   */}

                <div className="slider-activation slider-creative-agency with-particles" id="home">

                { false &&
                <div className="frame-layout__particles">
                <Particle
                    init={this.customInit}
                    options={{
                        fullScreen: { enable: false },
                        fpsLimit: 120,
                        interactivity: {
                        events: {
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                        },
                        },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 150,
                            enable: true,
                            opacity: 0.5,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        fullScreen: { enable: false },
                        move: {
                            direction: "none",
                            enable: true,
                            outModes: {
                                default: "bounce",
                            },
                            random: false,
                            speed: 2,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 20,
                        },
                        opacity: {
                            value: 0.5,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                }}

                />;

    </div>
    }


                    <div className="bg_image" style={{backgroundImage: 'linear-gradient(rgb(0 0 0 / 50%), rgb(91 18 237 / 95%)), url(/assets/images/banner-dojofullstack-2025.webp)', paddingBottom: window.location.pathname.includes("masterclass") && !this.state.showWeb ? "99px": "" }}>
                            




<div className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center" style={{flexWrap: "wrap"}}>




<div className="container mt-0">






{(this.state.showWeb && this.state.fechaLimite) && (window.location.pathname.includes("descuento")) &&

<div className="col-12 px-0">
<div className="d-inline-flex">

<a href="#empezar">
    <div id="counter-deadline" className="pt-1 pb-2 timer-bar " style={{backgroundColor: "tomato", marginTop: window.type_device ? "0px": "10px"}}> 
                {/* <h5 className="w-100 mt-2 mb-1 text-white text-center px-1" style={{fontSize: "17px"}} > 
                    {this.state.porcentajeDescuento}
                </h5> */}
                <div style={{display: "flex", flexDirection: window.type_device ? "column": "row", justifyContent: "center", alignItems: "center"}}>
                  <h5 className="my-1" style={{fontFamily: "'Poppins',sans-serif", fontSize: "16px", color: "white", textAlign: "center"}} >
⏳ El descuento exclusivo se cierra en:
                </h5>
                <div style={{marginLeft: window.type_device ? "0px": "20px", marginRight: window.type_device ? "0px": "20px", lineHeight: "1.25rem"}}>
                        <FlipCountdown
                                    size={'small'}
                                    yearTitle='Year'
                                    dayTitle='Days'
                                    hourTitle='Horas'
                                    minuteTitle='Min'
                                    secondTitle='Segs'
                                    monthTitle=''
                                    hideYear
                                    hideMonth
                                    hideDay
                                    
                                    endAt={this.state.fechaLimite} // Date/Time
                                    onEnd={() => {
                                        window.location.href = "/";
                                    }}
                                    />
                 </div>    
             
                 </div>
              
            </div>
            </a>


</div>

</div>
}

{(this.state.showWeb && this.state.fechaLimite) && (!window.location.pathname.includes("descuento")) &&

<div className="col-12 px-0">
<div className="d-inline-flex">


    <div onClick={() => {
                // this.setState({isOpenMett: true});
                const element = document.querySelector('#fechas');
            element.scrollIntoView({ behavior: 'smooth' });
                window.fbq('track', 'AddToCart', {
                    value: 2000,                 // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp'
                });
            }}  id="counter-deadline" className="pt-1 pb-2 timer-bar " style={{backgroundColor: "tomato", marginTop: window.type_device ? "0px": "10px"}}> 
                {/* <h5 className="w-100 mt-2 mb-1 text-white text-center px-1" style={{fontSize: "17px"}} > 
                    {this.state.porcentajeDescuento}
                </h5> */}
                <div style={{display: "flex", flexDirection: window.type_device ? "column": "row", justifyContent: "center", alignItems: "center"}}>
                  <h5 className="my-1 p-1" style={{fontWeight: "bold", fontFamily: "'Poppins',sans-serif", fontSize: "16px", color: "white", textAlign: "center"}} >
🚨 18 Final Spots – Enrollment Closes In:
                </h5>
                <div style={{marginLeft: window.type_device ? "0px": "20px", marginRight: window.type_device ? "0px": "20px", lineHeight: "1.25rem"}}>
                        <FlipCountdown
                                    size={'small'}
                                    yearTitle='Year'
                                    dayTitle='Days'
                                    hourTitle='Hours'
                                    minuteTitle='Min'
                                    secondTitle='Secs'
                                    monthTitle=''
                                    hideYear
                                    hideMonth
                                    endAt={this.state.fechaLimite} // Date/Time
                                    />
                 </div>    
             
                 </div>
              
            </div>
     


</div>

</div>
}
 
                                    <div className="row" style={{flexWrap: 'nowrap', marginTop:  !window.type_device || window.location.pathname.includes("descuento") ? "50px": "50px", justifySelf: window.location.pathname.includes("masterclass") && !this.state.showWeb ? "center": ""  }}>

                                        <div className="col-12" style={{paddingLeft: window.type_device ? "": "50px", paddingRight: window.type_device ? "": "50px"}}>

                                                <div className="inner text-left" style={{"text-align-last": "left"}}>

                                                    {true &&
                                                    <>
                                                        <h1 className="title" style={{fontSize: window.type_device ? "": "61px", marginTop: window.type_device ? "10%": "19px", "text-align": "left", marginBottom: window.type_device ? "1px": "25px", lineHeight: "30px"}}>
                                                            BootCamp
                                                        </h1>
                                                    <h1 className="title" style={{"text-align": "left", marginBottom: "10px"}}>
                                                         <span className="mt-2 h1-dojopy title title-gradient">
Full Stack Developer
                                                            </span>
                                                    </h1>
                                                    </>
                                                    }
                                                 

                                           
                                            <>
                                           
                                                      <div className="row col-12 mb-3" style={{textAlign: "left", height: "60px"}}>
                                                    <TypingAnimation/>
                                                    </div>
                                                    <p className="description" style={{"padding-top": "9px", fontSize: "17px"}}>


                                                    <div className="row">

                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                        <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>

                                                    <span style={{alignItems: "center", display: "inline-flex", padding: "2px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "5px", "padding-right": "5px", "color": "white", "font-size": "16px", fontWeight: "bold"}}>
                                                        <span className="pulsar mr-1"></span> {true ? "Live": "Live"}
                                                    </span>

                                                            
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                            <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                            <CiCalendar className="mr-1" style={{fontSize: "25px"}} /> Duration: 4 months
                                                         </div>
                                                    </div>

                                                    <div className="row">
                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                            <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                            <GoRocket className="mr-1" style={{fontSize: "25px"}} /> Project-based
                                                         </div>
                                                    </div>
                                                    


                                                    <div className="row">
                                                        <div style={{"text-align-last": "right"}} className="col-1 mx-0 px-0"><FiCheck style={{"color": "yellow"}}/></div>
                                                        <div className="col pr-0" style={{fontSize: "17px", paddingBottom: "9px", textAlign: "left" }}>
                                                        <MdWorkOutline className="mr-1" style={{fontSize: "25px"}} /> Real Job Preparation

                                                         </div>
                                                    </div>
                                      


                                                    </p>
                                                     </>
                                            




{ this.state.showWeb &&  this.state.price_completo_2 &&
<>




  <div className="d-flex" style={{gap: "9px", flexDirection: "column"}}>
        <div className="slide-btn mt-3">

            <button onClick={() => {
                // this.setState({isOpenMett: true});
                    const element = document.querySelector('#fechas');
                    // // Scroll hacia el elemento con smooth
                    element.scrollIntoView({ behavior: 'smooth' });
                    // Luego ajustamos hacia arriba con un pequeño delay
                    window.fbq('track', 'AddToCart', {
                        value: 2000,                 // Valor total de la compra
                        currency: 'USD',               // Moneda utilizada (ISO 4217)
                        content_type: 'product',       // Tipo de contenido
                        content_ids: ['bootcamp'],  // ID del producto o identificador
                        content_name: 'bootcamp'
                    });

                } }
                className="btn-efect-2 mt-1 cta-button" style={{borderRadius: "19px", background: "linear-gradient(180deg, #9b37f2, #7a12d4)", fontWeight: 600, padding: "10px 25px", fontSize: '20px', textTransform: "none", fontFamily: "Poppins, sans-serif"}}
                >

                   <GoRocket className="mr-1" /> Start Enrollment

             </button>
 

    </div>

</div>


 <div className="d-flex" style={{gap: "9px", flexDirection: "column"}}>
        <div className="slide-btn mt-3">

            <button onClick={() => {
                this.setState({isOpenBrochure: true});
                    // const element = document.querySelector('#fechas');
                    // // Scroll hacia el elemento con smooth
                    // element.scrollIntoView({ behavior: 'smooth' });
                    // Luego ajustamos hacia arriba con un pequeño delay

                    window.fbq('track', 'AddToCart', {
                        value: 2000,                 // Valor total de la compra
                        currency: 'USD',               // Moneda utilizada (ISO 4217)
                        content_type: 'product',       // Tipo de contenido
                        content_ids: ['bootcamp'],  // ID del producto o identificador
                        content_name: 'bootcamp'
                    });

                } }
                className="btn-efect-2 mt-1 cta-button" 
                style={{color: "#1f1f25", borderRadius: "19px",  background: "linear-gradient(180deg,#ffe26d,#f5c918)", fontWeight: 600, padding: "10px 25px", fontSize: '20px', textTransform: "none", fontFamily: "Poppins, sans-serif"}}
                >
                   <IoIosDocument className="mr-1" /> Download syllabus

             </button>
    </div>

</div>
</>
    }









{ this.state.showWeb &&
                    <div className="mt-3 text-left">
                    <img alt="" height={"99px"} src="/assets/images/dojopy/dojofullstack_report.png" />
                
                    </div>
    }



                    </div>

                 

                                            </div>


           

                                        </div>
</div>
    







                                </div>
  
                            

                        </div>


                                         
                </div>
                                   
                {/* End Slider Area   */}









      {false && window.location.pathname.includes("masterclass") &&
<div className="container mt-0">
                    <div className="col-12 w-100 px-0 mx-0 col-md-7" style={{marginTop: "1px"}} >
                         {!this.state.showWeb &&
                               <h5 className="mt-0 mb-3 mx-3 text-white text-center" style={{fontWeight: "normal", marginBottom: "3px", fontSize: "16px"}}>
                        🎬 Clic sobre el streaming, para empezar.
                        </h5>  
                    }               
                        
                        <iframe style={{borderRadius: "8px", marginTop: this.state.showWeb ? "33px": "1px" }} id="iframe-video" allowFullScreen frameborder="0"  border="none" width={"100%"} height={"auto"}
                        src={`https://player.dojofullstack.com/?url=${VIDEO_VLS}`}></iframe>

{this.state.showWeb &&
<h3 className="mb-0 mt-3 text-white"
                     style={{fontWeight: "500", display: "inline-block", padding: "3px", "padding-left": "20px", "padding-right": "20px", "font-size": window.type_device ? "18px": "25px" }}>
<b>
✅ Si ya viste la masterclass, descubre nuestro Bootcamp Full Stack Developer y accede a un descuento especial antes de que termine el contador.
<br/>
¡Asegura tu lugar hoy mismo!

</b>
                    </h3>
}


                      </div>   
           </div>                
    }


              
{this.state.countryCode !== "US" &&  this.state.showWeb && 
<div className="about-wrapper" style={{paddingTop: window.type_device ? "20px": "29px", paddingBottom: "5px", background: "white" }}>
<div data-aos="fade-top"  className={window.type_device ? "container-fluid ": "container"}>

 <div className="d-flex mt-1 text-dark" style={{flexDirection: window.type_device ? "column": "row", gap: window.type_device ? "1px": "15px", justifyContent: "center", alignItems: "center"}}>

 <div className="d-flex mb-3 col-md-5" style={{borderRadius: "20px", border: "1px solid mediumpurple", padding: "5px", alignItems: "center"}}>
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="89px" src="/assets/images/dojopy/murk_news.webp" />
    <div className="ml-2 mt-2">
      <h5 style={{fontSize: "17px", color: "#1f1f25", fontStyle: "normal"}} className="my-0">Elon Musk
        <span style={{marginLeft: "5px", fontSize: "13px", color: "mediumseagreen"}}>CEO SpaceX & Twitter</span>
      </h5>
      <p style={{fontSize: "14px", fontStyle: "normal"}}>La vida es demasiado corta para ser pequeña. Tienes que hacer algo grande.</p>
    </div>
  </div>

<div className="d-flex mb-3 col-md-5" style={{borderRadius: "20px", border: "1px solid mediumpurple", padding: "5px", alignItems: "center"}}>
    <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="89px" src="/assets/images/dojopy/elonmusk_news.webp" />
    <div className="ml-2 mt-2">
      <h5 style={{fontSize: "17px", color: "#1f1f25", fontStyle: "normal"}} className="my-0">Mark Zuckerberg
        <span style={{marginLeft: "5px", fontSize: "13px", color: "mediumseagreen"}}>CEO Facebook</span>
      </h5>
      <p style={{fontSize: "14px", fontStyle: "normal"}}>
      El miedo a lo desconocido nos limita; arriesgarse es clave para conocer nuestras capacidades.
        </p>
    </div>
  </div>



</div>
</div>
</div>
    }



{this.state.showWeb && 
  <div data-aos="fade-up" className="about-area bg_color--5" id="about_dojopy" style={{marginTop: "20px", marginBottom: "30px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">

                                                {window.type_device &&
                                                <>
                                                      Full Stack Developer
                                                </>}

                                                {!window.type_device &&
                                                <>
    Full Stack Developer
                                                </>}


                                            </h2>
                                            <p>

<b>
Dojofullstack is an educational startup that empowers new creators in the tech world, training developers with a practical focus and an innovative mindset.



</b>
                                            </p>
<p>
We were born with the mission of empowering talent and responding to the growing global demand for developers.
</p>
<p>
Our purpose is to close the skills gap, create more opportunities, and train thousands of people who want to actively participate in the digital transformation and technological advancement of companies.
</p>


                                          

                                        </div>

                             <div className="row mt--30 rn-address" style={{ boxShadow: "#c6c9d8 8px 6px 15px 1px" }}>
  <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{ marginTop: window.type_device ? "10px" : "1px" }}>
    <div className="about-us-list">
      <h3 className="title"><FiClock /> Duration</h3>
      <p style={{ fontSize: "17px" }}>
        <span style={{ color: "slateblue", fontSize: "18px" }}>
          <FiCheckCircle style={{ fontSize: "21px", marginRight: "7px", color: "slateblue" }} />
        </span>
        <b>4 months</b> <br />
        🕓 Flexible schedule
      </p>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{ marginTop: window.type_device ? "10px" : "1px" }}>
    <div className="about-us-list">
      <h3 className="title"><FiUser /> Modality</h3>
      <p style={{ fontSize: "17px" }}>
        <span style={{ color: "slateblue", fontSize: "18px" }}>
          <FiCheckCircle style={{ fontSize: "21px", marginRight: "7px", color: "slateblue" }} />
        </span>

        <span style={{
          display: "inline-block",
          padding: "3px",
          marginLeft: "7px",
          backgroundColor: "tomato",
          borderRadius: "7px",
          paddingLeft: "7px",
          paddingRight: "7px",
          color: "white",
          fontSize: "18px"
        }}>
          <span className="pulsar"></span> Live
        </span>
      
      </p>
    </div>
  </div>

  <div className="col-lg-4 col-md-6 col-sm-12 col-12" style={{ marginTop: window.type_device ? "10px" : "1px" }}>
    <div className="about-us-list">
      <h3 className="title">Level</h3>
      <p style={{ fontSize: "17px" }}>
        <span style={{ color: "slateblue", fontSize: "18px" }}>
          <FiCheckCircle style={{ fontSize: "18px", marginRight: "7px", color: "slateblue" }} />
        </span>
        No previous experience required. Start from scratch and go far!
      </p>
    </div>
  </div>

  <div className="col-12 mt-3">
    <div className="about-us-list">
      <h3 className="title">Syllabus</h3>
        <button
          onClick={() => {
            this.setState({isOpenBrochure: true});
            window.fbq('track', 'AddToCart', {
              value: 2000,
              currency: 'USD',
              content_type: 'product',
              content_ids: ['bootcamp'],
              content_name: 'bootcamp'
            });
          }}
          style={{
            textShadow: "none",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "19px",
            padding: "10px 19px",
            borderRadius: "20px",
            background: "linear-gradient(180deg,#ffe26d,#f5c918)",
            color: "black",
            border: "none",
            outline: "none"
          }}
          className="btn-efect-live"
        >
          <IoIosDocument className="mr-2" />
          View Syllabus
        </button>
    </div>
  </div>

  <div className="col-12 mt-3">
    <h3 className="title"><FaGraduationCap /> Certification</h3>
    <div className="row">
      <div className="about-us-list col-12 col-md-4">
        <img
          onContextMenu={(e) => e.preventDefault()}
          alt="Web Full Stack Developer Certificate"
          src={"/assets/images/dojopy/certify-fullstack-usa.png"}
        />
      </div>
    </div>
  </div>
</div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

}




      

                {this.state.showWeb && 
    <div data-aos="fade-right" className="about-area ptb--120 bg_color--5" id="benefits" style={{marginTop: "-50px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">
                                           Do you identify with any of these profiles?

                                            </h2>
                                    
                                        </div>


                                  <TouchCarousel
                                        component={Container2}
                                        cardSize={cardSize2}
                                        cardCount={dataUSA.length}
                                        cardPadCount={cardPadCount}
                                        loop={true}
                                        autoplay={2e3}
                                        renderCard={this.renderCard2}
                                        />


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }




{this.state.showWeb && 
    <div data-aos="fade-right" className="about-area ptb--120 bg_color--5" id="benefits" style={{marginTop: "-100px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title mb-0">
                                           What is Full Stack Development?


                                            </h2>

                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                        </div>
                                        <div>
                                            <p>
Can you imagine having the ability to build web and mobile applications from scratch? Become a Full Stack Developer and master the art of crafting irresistible digital experiences!
You'll learn to manage the entire development process — from visual design and server logic to database management.
With these skills, you'll not only build interactive websites and applications but also unlock a world full of tech opportunities and professional rewards. 🚀
                                            </p>
   <p>
The time is now! The tech industry is booming, with over 100,000,000 IT job openings waiting to be filled. Take the leap and become part of this digital revolution. This is your chance to stand out! 🚀


   </p>
                                         
                                        </div>

                               

                                    </div>
                                </div>

                   
                            </div>
                        </div>
                    </div>
                </div>
    }



{this.state.showWeb && 
    <div data-aos="fade-right" className="about-area ptb--120 bg_color--5" id="profile" style={{marginTop: "-100px"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12 col-md-9">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">
                                            {false ? "Un vistazo a tu futuro perfil ": "A look at your future profile"}
                                            </h2>
                                            <h3 className="title mt-4">
                                             {false ? "¿Qué trabajos podré conseguir?": "prestigious position"}
                                            </h3>
                                        </div>
                                        <div>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}> {false ? "Full Stack Developer ": "Full Stack Developer "} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>{false ? "Desarrollador Frontend ": "Front End Developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}> {false ? "Desarrollador Backend": "Backend Developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>{"App Developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}> {false ? "Desarrollador Cloud": "cloud developer"} </span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>  Web Developer</span>
                                        <span className="bg-white m-1" style={{padding: "5px 7px", border: "1px solid mediumpurple", display: "inline-block", borderRadius: "10px", fontSize: "18px"}}>Programmer Analyst </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12">
                                            <h3 className="title mt-4">
                                            {true ? "Professional Profile Upon Completing the Bootcamp": "Interesting activities"}
                                            </h3>
                                            <div>
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                   You’ll gain the ability to develop, design, and prototype modern web and app interfaces using cutting-edge technologies, enabling you to build more complex, dynamic, and scalable applications.
                                                </p>
                                               
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Define the required functionalities and the scope of external libraries for a web application.
                                                </p>
                                             
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                   Build user-friendly web interfaces.
                                                </p>

                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Deploy and implement web applications in the cloud.
                                                </p>

                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Develop software for businesses.

                                                </p>
                                                <p style={{fontSize: "17px", "margin-bottom": "10px"}}>
                                                    <span style={{"color":"slateblue", "fontSize": "20px"}}> <FiCheckCircle style={{fontSize: "21px", marginRight: "7px", color: "slateblue"}} /> </span>
                                                    Create awesome digital products as part of a team.
                                                </p>

                                                

                                            </div>
                                    </div>

                                    <div className="col-12 col-md-9">
                                            <h3 className="title mt-4">
                                             {false ? "Habilidades claves para el mercado laboral": "Key skills for the labor market"}
                                            </h3>
                                            <div>
                                            <TouchCarousel
                                                component={Container}
                                                cardSize={cardSize}
                                                cardCount={data.length}
                                                cardPadCount={cardPadCount}
                                                loop={true}
                                                autoplay={2e3}
                                                renderCard={this.renderCard}
                                                />
                                            </div>
                                    </div>


                                    <Tabs>


    {
        <TabPanel>
            <div className="row">
            <div className="col-12">
            <h3 className="title mt-4">
            <FaLinkedin  className="mr-1"/> {false ? "Salario alto y perspectivas seguras": "High salary and secure prospects"}
            </h3>
            <p style={{fontSize: "13px"}}>{false ? "Estos salarios mensuales promedio están tomados de Glassdoor, el portal de empleo líder. Pero tú puedes ser mejor que el promedio.":
            "These average monthly salaries are taken from Indeed and Glassdoor, the leading job portal in the United States. But you can be better than average."} </p>
            
              <div className="row">
                    <div style={{boxShadow: "3px 2px 6px 0px #808080b0"}} className="p-3 m-2 bg-white col-10 col-md-6">
                        <h3 style={{fontWeight: "bold"}}>{ "$90,000 USD / year"}</h3>
                        <p>{true ? "Full Stack Developer": "Junior Full Stack Developer Developer"}  <span className="text-primary d-inline-block"> {false ? "después del Bootcamp": "after bootcamp"}  </span> </p>
                    </div>

            <div style={{boxShadow: "3px 2px 6px 0px #808080b0"}} className="p-3 m-2 bg-white col-10 col-md-6">
                        <h3 style={{fontWeight: "bold"}}>{ "$150,000 USD / year"}</h3>
                        <p>{true ? "Full Stack Developer Sr.": "Junior Full Stack Developer Developer"}  <span className="text-primary d-inline-block"> {true ? "Senior Exp.": "Senior Exp."}  </span> </p>
                    </div>
                    

                    <div  className="m-1 col-12 col-md-3">
                        <img alt="El sector de la programacion web está prosperando" src="/assets/images/dojopy/top-thrending-2025.png"/>
                    </div>
            </div>
         
        </div>
 
            </div>

        </TabPanel>
    }
        <TabPanel>
            <div className="row">

        <div className="col-12">
            <h3 className="title mt-4">
            {false ? "Salario alto y perspectivas seguras": "High salary and secure prospects"}
            </h3>
            <p style={{fontSize: "13px"}}>{true ? "Estos salarios mensuales promedio están tomados de Glassdoor, el portal de empleo líder en Estados Unidos. Pero tú puedes ser mejor que el promedio.":
            "These average monthly salaries are taken from Indeed and Glassdoor, the leading job portal in the United States. But you can be better than average."} </p>
              <div className="row">
                    <div style={{boxShadow: "3px 2px 6px 0px #808080b0"}} className="p-3 m-2 bg-white col-10 col-md-6">
                        <h3 style={{fontWeight: "500"}}>{true ? this.state.salario_fullstack_jr: "$70,000 / year"}</h3>
                        <p>{true ? "Full Stack Developer": "Junior Full Stack Developer Developer"}  <span className="text-primary d-inline-block"> {true ? "después del Bootcamp": "after bootcamp"}  </span> </p>
                    </div>

                    <div  className="m-1 col-12 col-md-3">
                        <img alt="El sector de la programacion web está prosperando" src="/assets/images/dojopy/top-thrending-2025.png"/>
                    </div>
            </div>
         
        
        </div>
    
        </div>
        </TabPanel>
    </Tabs>


                            </div>
                </div>
            </div>
        </div>

            }





{false && 
          <div data-aos="fade-right" className="about-area ptb--30 bg_color--5">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            <div className="text-center col-12">
                                <h3 className="title"> {true ? "Tu portafolio de proyectos": "Your portfolio of projects"}</h3>
                            </div>

                                <div className="col-md-4 col-6">

                                    <div className="thumbnail zoom">
                                        <img alt="proyecto web personal" style={{maxHeight: "470px", maxWidth: "470px", transition: "0.2s"}} className="w-100" src="/assets/images/dojopy/project1.webp"/>
                                        <p style={{padding: "13px"}}>{true ? "Web Personal": "Personal website"} </p>
                                    </div>
                                </div>

                                <div className="col-md-4 col-6">
                                    <div className="thumbnail zoom">
                                        <img alt="proyecto Web para negocios" style={{maxHeight: "470px", maxWidth: "470px", transition: "0.2s"}} className="w-100" src={true ? "/assets/images/dojopy/project2.webp" : "/assets/images/dojopy/doctor-web-us.webp"} />
                                        <p style={{padding: "13px"}}>{true ? "Web para empresas": "Website for companies"} </p>
                                    </div>
                                </div>



                                <div className="col-md-4 col-12">
                                    <div className="thumbnail zoom">
                                        <img  alt="proyecto Web de Pedidos inspirada en Rappi" style={{maxHeight: "470px", maxWidth: "470px", transition: "0.2s"}} className="w-100" src={true ? "/assets/images/dojopy/project4.webp": "/assets/images/dojopy/amazon_project.png"}/>
                                        <p style={{padding: "13px"}}>{true ? <>Web de Pedidos inspirada en <b>Rappi.com</b> </>: <>Commerce website inspired by <b>Amazon.com</b> </>} </p>
                                    </div>
                                </div>

                            </div>




                        </div>
                    </div>
                </div>

    }





{this.state.showWeb && 
   <div data-aos="fade-right" className="about-area ptb--10 bg_color--5"  style={{marginTop: "1px", color: "#1f1f25"}}>
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                            <div className="text-center col-12">
                         

                                                            <div className="section-title">
                                <h2 className="title text-black mb-1" style={{padding: "5px"}}>
                                How Does the Bootcamp Work?
                                    </h2>

                                                            </div>

                            </div>
                               <div className="p-1">

      

<p style={{fontSize: "18px"}}>
  <span style={{color: "goldenrod", fontSize: "20px"}}>
    <FiCheckCircle style={{fontSize: "29px", marginRight: "7px", color: "goldenrod"}} />
  </span>
  <b>Live Online <br/> (scheduled sessions):</b>
</p>
<ul>
  <li><b>Direct and structured interaction to maximize your learning:</b></li>
  <li><b>Weekly group classes</b> with a live expert instructor</li>
  <li><b>Practical exercises</b> each week to reinforce concepts</li>
  <li><b>Personalized live coaching</b> to resolve specific questions</li>
</ul>




                                   {/* <p>
                                   {true ? <>
                                    Cada semana tendrás <b>2 encuentros grupales en vivo</b> con el Instructor, al final de cada semana hay actividades prácticas, no te preocupes si te trabas en las actividades siempre tendrás asesorías personalizadas.
                                   <br/>
                                   En DojoFullStack proponemos un nuevo modelo educativo que incluye entornos de aprendizaje sincrónicos y Asíncronos con un enfoque que vincula la teoría y la práctica, mediante un aprendizaje activo.
                                   </>: <>
                                   Each week you will have <b>2 live group meetings</b> with the Instructor, at the end of each week there are practical activities, don't worry if you get stuck in the activities you will always have personalized advice.
                                    <br/>
                                    At DojoFullStack we propose a new educational model that includes synchronous and asynchronous learning environments with an approach that links theory and practice, through active learning.
                                   </> }
                                    </p> */}

                                    <div className="row mt--30">
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                {false ? "Conéctate a tu primera sesión ": "Connect to your first session"}

                                                            <span style={{padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                            <span className="pulsar"></span> {true ? "Live": "Live"}
                                                            </span>
                                                </h4>
                                                <img alt="Conéctate a tu primera sesión en vivo" height="190px" src="/assets/images/dojopy/live_zoom.webp" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                {true ? "Asynchronous Activities on the Platform": "Practice with new challenges and activities every week"}
                                                </h4>
                                                <img style={{borderRadius: "20px"}}  alt="Practica con nuevos retos y actividades cada semana" height="159px" src="/assets/images/dojopy/plataform_2026_elear.png" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                1:1 Mentorship Sessions
                                                </h4>
                                                <img alt="Recibe asesoría personalizada 1 a 1" height="135px" src="/assets/images/dojopy/live-mentoring-1-1.png" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 mt-3">
                                            <div style={{"text-align":"center", "box-shadow": "4px 2px 5px 0px #8080805e", "border-radius": "30px", "padding": "25px", "background": "white"}}>
                                                <h4>
                                                Share your projects everyone learns more that way!
                                                </h4>
                                                <img style={{borderRadius: "20px"}} alt="Presenta y comparte tus proyectos." height="139px" src="/assets/images/dojopy/project_social_news.png"></img>
                                            </div>
                                        </div>
                                    </div>
                               </div>

                            </div>
                        </div>
                    </div>
                </div>

}
             

                {window.location.pathname.includes("descuento") ? <>
                     <div className="mb-2 mt-3" style={{paddingTop: "37px"}}  >
                </div>
                </>:
                <>
                   <div className="mb-2 mt-3" style={{paddingTop: "37px"}}  >
                </div>
                </>
                }










{this.state.showWeb && 
                <div data-aos="fade-right" className="about-area ptb--60 bg_color--5" id="frontend">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">

                                <div className="col-12 mt-3 mb-3">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title pb-3">{false ? "¿Cuáles serán los Módulos?": "Main modules"}</h3>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/coder_frontend.webp" alt="primer módulo web frontend"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                 
                                            <h2 className="title mb-0">Frontend Web</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                                <b> {false ? "Conviértete en quien crea las interfaces que los usuarios aman.": "Become the one who creates the interfaces that users love."} </b>
                                            </p>

                                            {!this.state.showMoreC &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreC: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                 {true ? "Show more": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}
                                            </div>

                            {this.state.showMoreC &&
                            <>
                            <p>
                        More and more companies are looking for frontend developers who can understand and contribute to web applications with user-friendly, modular interfaces to enable agile development and proper usability.
<br/>

This role specializes in designing and building everything users see and interact with in a web application — buttons, images, forms, and more. It's a key skill for ensuring a strong user experience with digital products.
<br/>

In this program, you'll learn everything from programming fundamentals to launching web applications using the latest technologies in the market, such as ReactJS.
                                            </p>
                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> HTML</h4>

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> CSS/SASS</h4>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Javascript</h4>

                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                    <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> React JS</h4>

                                                </div>
                                            </div>
                                        </div>

                                        </>}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

}



{this.state.showWeb && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="git_github">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/git_github_coder.webp" alt="segundo módulo Git"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                               
                                            <h2 className="title mb-0">Git & Github</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
Learn all the essential tools to master the world of collaborative programming. You'll gain the foundational knowledge and core concepts needed to work on professional projects, whether in a company or as part of a team of developers. With this module, you'll acquire everything you need to confidently contribute to any developer group.                                            </p>

                                        </div>
                {true &&
                <>

                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Git</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Github</h4>
                                                </div>
                                            </div>
                                         
                                        </div>
                                        </>}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
}


{this.state.showWeb && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="WEB_DEployment">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/web_deplyment_coder.webp" alt="tercer módulo"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                         
                                            <h2 className="title mb-0">{true ? "Deployment": ""} </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                         <b>
In this module, you’ll master the deployment of complete applications to the cloud: you’ll learn how to publish your project on Vercel, Netlify, and AWS Amplify, configure TLD domains, activate SSL certificates, and secure your application in just a matter of minutes.
                                            </b>  </p>
                                        </div>
                                  

            {true &&
                <>
                                     
                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Vercel & Netlify  </h4>
                                                </div>
                                            </div>
                                               <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>AWS Amplify </h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> SSL & Domain TLD </h4>
                                                </div>
                                            </div>

                                               <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> WAF Security </h4>
                                                </div>
                                            </div>
                                       
                                        </div>
                                        </>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }


{this.state.showWeb && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="backend">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/module-6.png" alt="segundo módulo web Backend"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                               
                                            <h2 className="title mb-0">Backend </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                                <b>{false ? "Conviértete en quien crea la lógica detrás de todas las aplicaciones web": "Become the one who creates the logic behind all web applications"} .</b>
                                            </p>

                                        </div>


                                        {!this.state.showMoreD &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreD: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Show more": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

                {this.state.showMoreD &&
                <>


                                            <p>
  More and more companies are looking for backend developers who can understand and build web applications that provide everything needed to serve their users effectively.
<br/>

This role specializes in creating APIs, databases, and scalable architectures — in other words, everything that happens behind the scenes but is essential for the functionality of the applications and websites we use every day.
<br/>

In this bootcamp, you’ll learn everything from the fundamentals of programming to launching solid web applications using the latest technologies in the industry.
                                            </p>


                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Node JS</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Python</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> REST / RESTfull / APIs</h4>
                                                </div>
                                            </div>
                                    
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Authentication JWT</h4>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Relational and NoSQL Databases</h4>
                                                </div>
                                            </div>

                                             <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>  Cloud Databases</h4>
                                                </div>
                                            </div>

                                        </div>
                                        </>}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
}



{false && 
                <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="db">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/module-8.png" alt="tercer módulo bases de datos"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                         
                                            <h2 className="title mb-0">{true ? "BASES DE DATOS": "DATABASES"} </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                                            <p>
                                         <b>
                                         Construye tus propios modelos de bases de datos con las mejores prácticas desde cero
                                            </b>  </p>

                                        </div>

                                        {!this.state.showMoreE &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreE: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Show more": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

            {this.state.showMoreE &&
                <>

                                            <p>
        Antes de utilizar cualquier tecnología para bases de datos debes entender los fundamentos de diseño y modelado
         requeridos para que tengas la mejor arquitectura posible.

                                            </p>
                                    <div className="row mt--30">
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Fundamentos</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Bases de Datos Relacionales (PostgreSQL)</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Bases de Datos no Relacionales (mongoDB/Mongoose)</h4>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                                <div className="about-us-list">
                                                <h4 className="title"><FiCheck style={{"color": "slateblue"}}/> Cloud Databases</h4>
                                                </div>
                                            </div>
                                        </div>
                                        </>}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }





{this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "250px": "390px"} src="/assets/images/dojopy/BOOTCAMP-apps-r.png" alt=""/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                                          
                                                          
                                            <h2 className="title mb-0">
                                                Mobile and Cross-Platform Apps
                                            </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                            <p>
                                        <b>
🚀 Build amazing apps with React Native! Learn to develop cross-platform mobile applications for iOS and Android using a single codebase. Design fast, modern experiences while optimizing time and resources. The future of mobile development is in your hands! 🌟                                    
                                        </b>  </p>


                                        </div>
              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }




{this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-80" height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/module-9.png" alt="Desplieque en Amazon Web Services"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                                          
                                                          
                                            <h2 className="title mb-0">{true ? "Cloud AWS": "DEPLOYMENT IN THE AWS CLOUD"}</h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                            <p>
                                        <b>{false ? "Sube tus aplicaciones web en la moderna arquitectura de AWS.": "Upload your web applications on the modern architecture of AWS."}  </b>  </p>

                                        {!this.state.showMoreF &&
                                            <div className="col-12 text-left">
                                                <button
                                                onClick={() => this.setState({showMoreF: true}) }
                                                type="submit"
                                                name="submit"
                                                id="mc-embedded-subscribe-"
                                                style={{ marginTop: "5px", marginBottom: "5px", fontSize: "18px",
                                                "border-radius": "20px",
                                                "border": "2px solid #6a5acd",
                                                "padding": "9px 20px"

                                            }}
                                                >
                                                {true ? "Show more": "Show more"} <br/>
                                                <AiOutlineDown style={{padding: "5px", fontSize: "30px"}}/>
                                                </button>
                                            </div>}

                                        </div>

                {this.state.showMoreF &&
                <>
                                        <p>
     AWS is one of the leading cloud computing service platforms in the world. It offers a broad range of infrastructure services such as computing power, storage options, networking, and databases — all available on demand, within seconds, and under a pay-as-you-go model where you only pay for what you use.

 <br/>
                                            </p>

                              <div className="row mt--30">
  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
    <div className="about-us-list">
      <h4 className="title"><FiCheck style={{ color: "slateblue" }} /> Databases</h4>
    </div>
  </div>
  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
    <div className="about-us-list">
      <h4 className="title"><FiCheck style={{ color: "slateblue" }} /> Private Server</h4>
    </div>
  </div>
  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
    <div className="about-us-list">
      <h4 className="title"><FiCheck style={{ color: "slateblue" }} /> Storage</h4>
    </div>
  </div>
  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
    <div className="about-us-list">
      <h4 className="title"><FiCheck style={{ color: "slateblue" }} /> Serverless Architecture</h4>
    </div>
  </div>
</div>


                                    </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }



{this.state.showWeb && 
    <div data-aos="fade-left"  className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height={window.type_device ? "197px": "350px"} src="/assets/images/dojopy/project-fullstack-web.webp" alt="proyecto startups"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <span style={{padding: "3px", marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "18px"}}>
                                                            <span className="pulsar"></span> {true ? "Live": "Live"}
                                                            </span>
                                            <h2 className="title mb-0">{false ? "Desarrollo de Proyectos": "Development"} </h2>
                                            <div style={{width: window.type_device ? "200px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                      
                                         <p>
Web applications developed from start to finish, integrating frontend, backend, databases, authentication, payment gateways, and cloud deployment.
                                            </p>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }







{ this.state.showWeb && 
 <div className="about-area ptb--60 bg_color--5" id="">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img height="297px" src="/assets/images/dojopy/TALENTO_search.webp" alt="PROGRAMA DE EMPLEO y ACELERACIÓN LABORAL"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                     
                                            <h2 className="title" style={{textTransform: "uppercase"}}>
                                               {true ? "Real-World Job Preparation": "EMPLOYMENT PROGRAM"}
                                            </h2>


                                    <div style={{width: window.type_device ? "197px": "395px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                  
<p>At DojoFullStack, we strongly believe in the quality of our training and the potential of our students. That’s why, upon completing the Bootcamp, you’ll gain access to <b>personalized 1-on-1 coaching</b> with a career readiness specialist.</p> <p>This support includes <b>optimizing your professional profile</b>, interview preparation, and guidance in crafting your job search strategy. Our goal is to ensure you’re <b>fully prepared to seize opportunities in the tech industry</b>, equipped with the tools and support you need to stand out in the market.</p>








                                          
                                </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }


{this.state.showWeb && 
                 <div className="about-area ptb--50 bg_color--5" id="platform">
                                   <div className="about-wrapper">
                                       <div className="container">
                                           <div className="row row--35 align-items-center">
                                               <div className="col-lg-5">
                                               <div data-aos="fade-up" className="thumb position-relative m-auto" style={{maxWidth: "500px"}}>
                                                       <img style={{boxShadow: "#32074061 8px 6px 15px 3px"}} className="w-100" src={!this.props.img ? "/assets/images/dojopy/plataforma-news-2025.webp": this.props.img} alt="plataforma_bootcamp"/>
                                                       {/* <ModalVideo channel='youtube' isOpen={this.state.isOpen0} videoId='-_IVPd1ryvI' onClose={() => this.setState({isOpen0: false})} /> */}
                                                       {/* <button className="video-popup position-top-center" onClick={this.openModal0}><span className="play-icon"></span></button> */}
                                                   </div>
                                               </div>
               
                                               <div className="col-lg-7">
                                                   <div className="about-inner inner">
                                                       <div className="section-title">
                                                      
                                                           <h2 className="title mb-0">  {!this.props.langUS ? "PLATFORM": "PLATFORM"} </h2>
                                                           <div style={{width: window.type_device ? "200px": "375px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                                         <>
                               <p>
                                All students and instructors have access to a platform where they find the materials,
                                 community, calendar and the links of the sessions by Zoom,
                                 In addition, the classes are recorded on the platform so that you can see them as many times as you want.
                                with unlimited access. <br/>
                                <b>
                                The platform is powered by Artificial Intelligence, which means you'll receive personalized lessons and feedback based on your progress.
                                </b>
                                </p>
                               </>
                                                      
                                                       </div>
                                                   <div className="row mt--30">
                                                       
                                                  
               
                                                           <div className="col-12">
                                                               <div className="about-us-list">
                                                               <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>
                                                               
                                                               {false ?  "Módulos Full Stack con actividades y revisiones.": "Full Stack modules with activities and reviews."}
                                                               </h4>
                                                               </div>
                                                           </div>
               
               
               
                                                           <div className="col-12">
                                                               <div className="about-us-list">
                                                               <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>  {false ? "Proyectos y soluciones compartidas en la comunidad.": "Access projects and shared solutions from the community."}
                                                               </h4>
                                                               </div>
                                                           </div>
                                                 
                                                           <div className="col-12">
                                                               <div className="about-us-list">
                                                               <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>  {false ? "Red social exclusiva para fomentar la interacción.": "Community (we created our own social network)."}
                                                               </h4>
                                                               </div>
                                                           </div>
               
                                                           <div className="col-12">
                                                               <div className="about-us-list">
                                                               <h4 className="title"><FiCheck style={{"color": "slateblue"}}/>  {false ? "Acceso completo de por vida.": "Lifetime full access."}
                                                               </h4>
                                                               </div>
                                                           </div>
               
                                                       
                                                       </div>
               
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                   </div>
                               </div>
}



{this.state.showWeb && 
                <div data-aos="fade-right" className="about-area ptb--20 " id="methodology">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">


                                 {window.type_device ? (
                                        <div className="col-12" style={{textAlign: "-webkit-center", marginLeft: "-45px", marginBottom: "-40px"}}>
                                            <ReactPlayer
                                            muted={true}
                                            loop={true}
                                            url={"/assets/video/demo_lite_1.mp4"}
                                            playing={true}
                                            width={400}
                                            height={250}
                                                />
                                        </div>
                                    ):(
                                        <div className="col-12" style={{textAlign: "-webkit-center"}}>
                                        <ReactPlayer
                                        muted={true}
                                        loop={true}
                                        url={"/assets/video/demo_lite_1.mp4"}
                                        playing={true}
                                        width={520}
                                        />
                                        </div>
                                    )}


                                <div className="col-12" style={{textAlign: "-webkit-center", paddingTop: "30px"}}>
                                    <div className="about-inner inner">
                                        <div className="section-title" style={{height: "103px"}}>
                                        {window.type_device ? (
                                            <h2>Learn online
                                                 <span style={{lineHeight: "17px", display: 'inline-block', padding: "3px",marginLeft: "7px", "background-color": "tomato", "border-radius": "7px", "padding-left": "7px", "padding-right": "7px", "color": "white", "font-size": "16px"}}>
                                                            <span className="pulsar"></span> En vivo
                                                            </span>
                                            
                                                 </h2>
                                        ): (
                                            <TypingAnimation2/>
                                        )}

                                        </div>

                                        <h4 style={{fontSize: "18px"}}>
At DojoFullStack, we propose a new educational model that includes synchronous and asynchronous learning environments with an approach that connects theory and practice through active learning.


                                            </h4>


                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
    }





                <div>
            </div>





    {/* Start Team Area  */}
    { this.state.showWeb &&
    <div data-aos="fade-up" className="rn-team-area ptb--10 bg_color--1" id="modules">
        <div className="container" style={{"maxWidth": "900px"}}>
            <div className="row">
                <div className="col-12">
                    <div className="text-center mb--30">
                        <h3 className="title">
                        {false ? "El Bootcamp está formado por los siguientes módulos":
                            "The Bootcamp is made up of the following modules"}
                            </h3>
                                    <div className="mx-auto mt-1" style={{width: window.type_device ? "197px": "200px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>


                    </div>
                    <div>
                <AccordionWrapper>
                    <AccordionItem  index={0} title={false ? "Fundamentos del Desarrollo y Programación": "Fundamentals of Web Development"} description={true ? InfoAcordeon.web: InfoAcordeonUS.web}></AccordionItem>
                    <AccordionItem  index={1} title={true ? "Git & Github": "Git & Github"} description={true ? InfoAcordeon.git: InfoAcordeonUS.git}></AccordionItem>
                    <AccordionItem  index={2} title={"Web Deployment"} description={InfoAcordeon.web_deploy}></AccordionItem>
                    <AccordionItem index={3} title={true ? "JavaScript": "JavaScript"} description={true ? InfoAcordeon.js: InfoAcordeonUS.js}></AccordionItem>
                    <AccordionItem index={4} title={false ? "Frontend con React JS": "Frontend with ReactJS"} description={true ? InfoAcordeon.react: InfoAcordeonUS.react}></AccordionItem>
                    <AccordionItem index={5} title={false ? "Bases de Datos": "Databases"} description={true ? InfoAcordeon.database: InfoAcordeonUS.database}></AccordionItem>
                    <AccordionItem index={6} title={false ? "Backend con Python y Django": "Backend with Python and Django"} description={true ? InfoAcordeon.python: InfoAcordeonUS.python}></AccordionItem>
                    <AccordionItem index={7} title={false ? "API REST": "API REST"} description={true ? InfoAcordeon.api: InfoAcordeonUS.api}></AccordionItem>
                    <AccordionItem index={8} title={false ? "Testing & Seguridad": "Testing & Security"} description={true ? InfoAcordeon.apiSecure: InfoAcordeonUS.apiSecure}></AccordionItem>
                    <AccordionItem index={9} title={false ? "Servicios en la nube con Amazon Web Services": "Deployment in the AWS cloud"} description={true ? InfoAcordeon.deploy_aws: InfoAcordeonUS.deploy_aws}></AccordionItem>
                    <AccordionItem index={10} title={false ? "Proyectos Full Stack Developer": "Full Stack Developer Project"} description={true ? InfoAcordeon.project: InfoAcordeonUS.project}></AccordionItem>
                    <AccordionItem index={12} title={false ? "Apps Multiplataforma": "Cross-Platform Apps"} description={true ? InfoAcordeon.appsMobiles: InfoAcordeonUS.project}></AccordionItem>
                    <AccordionItem index={13} title={false ? "Employability": "Employability"} description={true ? InfoAcordeon.employer: InfoAcordeonUS.employer}></AccordionItem>
                </AccordionWrapper>
                    </div>

                </div>
            </div>

        </div>

    </div>
    }
    {/* End Team Area  */}





{this.state.showWeb && 
                <div data-aos="fade-right" className="about-area ptb--20 bg_color--5" id="fechas">

                <div className="about-wrapper" style={{paddingTop: "20px"}} >
                <div className="container px-0">

                            <div className="section-title mb-3">
                            <h2 className="title text-center mb-1" style={{paddingBottom: "1px" }}>
                            Start Date
                            </h2>
                        
                            </div>

                        <div className="col-12">
                          <a href={`/en/enroll/${this.state.bootcampSlug}/${this.state.countryCode}`} style={{textDecoration: "none", color: "black"}}>
                        {this.renderFechas()}
                        </a>
                        </div>

                    </div>
                    </div>
                    </div>
    }



{this.state.showWeb &&

                <div className="rn-pricing-table-area ptb--40 bg_color--5" data-aos="fade-right" id="empezar">

<div className="container px-0" >
<div className="row" style={{justifyContent: "center", textAlign: "-webkit-center"}}>


<div className="col-12 mt-1 px-0" style={{paddingBottom: "13px", paddingRight: "15px", paddingLeft: "15px", maxWidth: "490px", marginRight: window.type_device ? "auto": "1px" }} >

<div  onClick={ () => window.fbq('track', 'AddToCart', {
                value: 2000,                 // Valor total de la compra
                currency: 'USD',               // Moneda utilizada (ISO 4217)
                content_type: 'product',       // Tipo de contenido
                content_ids: ['bootcamp'],  // ID del producto o identificador
                content_name: 'bootcamp'
            })}   className="rn-pricing"
            style={{boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "none", background: "#1f1f25", borderRadius: "20px"}} >
    <div className="pricing-table-inner">

        <div className="pricing-header pb-0 mb-2 mt-1">

{window.location.pathname.includes("descuento") && <div class="badge-oferta">🔥 OFERTA LIMITADA</div>}
                

        <h2 className="text-white p-0 m-0" style={{fontSize: window.type_device ? "29px": "33px"}}>Bootcamp
          </h2>

                  
        <h2 className="text-white" style={{fontSize: window.type_device ? "33px": "45"}}>
            Full Stack Developer</h2>
        <div className="mx-auto mt-1" style={{width: window.type_device ? "190px": "190px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

    

        <hr style={{borderTop:  "1px solid gray"}} />

            <span style={{color: "gray", display: "inline-block"}}>
            <del style={{color: "gray", fontSize: "23px"}}>
                &nbsp; {this.state.price_completo_regular_2} &nbsp;
            </del>
            </span>


            {this.state.porcentajeDescuento &&
                <div style={{display: "inline-block", fontSize: "13px", marginLeft: "5px"}} className="discount-badge inline-block"> {this.state.porcentajeDescuento} </div>
            }


            <h3 className="pricing" style={{margin: "5px"}} >
                  
            {this.renderPrice(this.state.price_completo_2)}


            </h3>

     
<div className="text-white my-3" style={{fontSize: "18px", fontWeight: "normal"}}>
   <p className="mb-1"><b style={{fontSize: "18px"}}> One-time payment of {this.state.price_completo_2} for your entire career.  </b>  </p>
</div>

 

            <div className="slide-btn" style={{marginTop: "20px", textAlign: "center"}}>
                <a href={`/en/enroll/${this.state.bootcampSlug}/${this.state.countryCode}`}>
                <button
                onClick={() => {
                    window.fbq('track', 'AddToCart', {
        value: 2000,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
} }
                id="enroll_bootcamp_2"
                style={{fontFamily: "'Poppins',sans-serif",  lineHeight: "28px", fontSize: "20px", marginBottom: "13px", padding: "15px 30px", textTransform: "uppercase", border: "1px solid white", borderRadius: "10px"  }}
                className="btn-efect-2 boton-bombeo">
                    <GoRocket style={{color: "mediumspringgreen", fontSize: "22px", marginRight: "10px"}}/>
                    Start Enrollment
                 </button>
                    </a>
        </div>
   



{/* <a href={this.state.linkPayUSD} target="_blank" style={{textDecoration: "none", color: "white"}}>
 <div className="mt-2 text-center">
                  
                  <button className="btn-efect" style={{backgroundColor: "#1f1f25", fontFamily: "Poppins, sans-serif", fontSize: "23px", margin: "5px", fontWeight: "bold", textTransform: "none", cursor: "pointer"}}
                      onClick={(e) => console.log("add cart")}
                  >
                    <IoCard className="mr-2" />
                    
                    {!window.location.pathname.includes("suscripcion") ? "Pagar con Tarjeta": "Suscribirse Ahora"}
                       
                  </button>
              </div>
</a>  */}

    {false && this.state.showPayal &&
                  <button id="comprar-paypal-button" style={{height: "99px", border: "none", width: window.type_device ? "100%": "370px", marginTop: "9px", marginBottom: "1px", alignSelf: "center", placeSelf: "center"}}>
                    <PayPalScriptProvider options={this.state.initialOptions} style={{height: "200px"}}>
                  

                    {window.location.pathname.includes("suscripcion") ?
                        <PayPalButtons
                            style={{ layout: "horizontal", label: "subscribe" }}
                            createSubscription={(data, actions) => {
                            // Reemplaza 'P-XXXXXXXXXX' por el ID de tu plan de suscripción creado en PayPal
                            return actions.subscription.create({
                                plan_id: "P-94D96700AX2739101NBGSLDA"
                            });
                            }}
                            onApprove={(data, actions) => {
                            // data.subscriptionID contiene el ID de la suscripción aprobada
                            window.location.href = `/payment-success?session_id=${data.subscriptionID}`;
                            }}
                        /> :
                             <PayPalButtons
                                    style={{ layout: "horizontal", label: "pay" }} // Cambia a 'vertical' para mejor disposición
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        purchase_units: [
                                            {
                                                amount: {
                                                    currency_code: "USD",
                                                    value: this.state.price_mount,
                                                },
                                            },
                                        ],
                                    });
                                }}
                                onApprove={(data, actions) => {
                                    return actions.order.capture().then((details) => {
                                        window.location.href = `/payment-success?session_id=${Math.floor(Date.now() / 1000)}&mount=${this.state.price_mount}`;
                                        // const name = details.payer.name.given_name;
                                        // console.log(`Transaction completed by ${name}`);
                                    });
                                }}
                            />
                    }
                    </PayPalScriptProvider>
                </button>
          } 

             



        </div>

            <div className="p-1 text-left mt-0 text-white">

        <div class="guarantee">
            <div class="guarantee-text">
              🛡️ 30-day satisfaction guarantee or your money back.
            </div>
        </div>


    <h4 className="text-white py-0 mt-2">
        {false ? "Métodos de pago: ": "Payment Methods:"}
    </h4>
    <p className="text-white my-1">
        Pay with debit or credit card.
         <br/>

    </p>


    <div style={{marginTop: "5px"}} className="section-title service-style--3 text-left mb--20 mb_sm--0 ">
<img height="70px" className="ayudar" src="/assets/images/dojopy/payment-card.png" alt="métodos de pago"/>


</div>


    </div>

    </div>
</div>

</div>


                            </div>


<div style={{marginTop: "20px"}} className="section-title service-style--3 text-left">
            

                    <div className="about-us-list row mt-1 guarantee"  >
                                <div className="col-12 col-md-1 text-left mb-3">
                                     <img width={window.type_device ? "55px": "55px" }  className="" src="/assets/images/dojopy/garantia-cash.png" style={{cursor: "pointer"}}/>
                                </div>
                                <div className="col-12 col-md-11 px-0 ">
                                    <h4 className="title" style={{fontWeight: "normal", textAlign: window.type_device ? "left": "left", fontSize: "16px"}}>
We offer a 30-day satisfaction guarantee: if our Full Stack Developer Bootcamp doesn't meet your expectations, we'll refund 100% of your investment, with no hidden clauses.                                    </h4>
                                </div>

                            </div>


                        <h5 className="title text-black mt-2" style={{fontSize: "18px"}}>

                        {true? "Once our support team has verified the payment, you will get:": "Una vez que nuestro equipo de soporte haya verificado el pago, obtendrás:"}

                                
                            </h5>
                        <p>
                            <ul>
                                <li>
                                {true ? "Get your credentials and access the Live Online Bootcamp Platform.": "Obtén tus credenciales y accede a la Plataforma del Bootcamp Online en Vivo."}
                                </li>
                                <li>
                                {true ? "Become part of our exclusive private members community and connect with other passionate people like you.": "Forma parte de nuestra exclusiva comunidad privada de miembros y conecta con otros apasionados como tú."}
                                </li>

                                <li>
                                {true ? "Enjoy the personalized support of an assigned mentor, always ready to guide and support you on your path.": "Disfruta del respaldo personalizado de un mentor asignado, siempre listo para guiarte y apoyarte en tu camino."}
                                </li>
                              
                            </ul>

                        
                             </p>
<p className="mt-4">
   If you have any questions, please write to us via email: <a href="mailto:hello@dojofullstack.com">hello@dojofullstack.com</a>
</p>





                    </div>
                    


                        </div>
                    </div>
                   
    }








{this.state.showWeb && 
    <>
     <div style={{marginTop: "20px"}} className="section-title service-style--3 text-center mb--25 mb_sm--0 text-center">
                    <h2 className="title">{false ? "Testimonios": "Testimonials"} </h2>
                </div>

                <div className="rn-testimonial-area bg_color--1 ptb--80">
                    <div className="container">
                        <TestimonialOne langUS={this.state.langUS}  country={this.state.countryCode} />

    
                        <div className="mt-3" style={{backgroundColor: "white", padding: "0", textAlign: "left"}}>
                  

                        <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                            <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/019209102.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Nathan Collins
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                 
<p style={{fontSize: "11px", fontStyle: "italic"}}>
    "As a computer science student, I felt I lacked practical experience to stand out in the job market. Thanks to the bootcamp, I was able to develop real projects and acquire current skills that aren't taught in university. Now, while finishing my studies, I'm already working as a Full Stack Developer at a tech company, earning more than $7,500/month. The bootcamp was the perfect complement to my career!"

    <br/>
    <b>
   Nathan Collins
 – , computer science student and Developer at a tech company.
    </b>
</p>

                            </div>
                          </div>
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_3.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Logan Carter
                                <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                              <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>
                              
                          <p style={{fontSize: "11px", fontStyle: "italic"}}>
   "I decided to enroll in the Full Stack Developer bootcamp and it was the best decision of my life. Now I have the opportunity to work with major companies and my income has improved significantly. Thank you Dojofullstack, for providing me with quality education!"
   <br/>
   <b>
      – Logan Carter, former beginner and now Developer at an international company.
   </b>
</p>
                            </div>
                          </div>
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_4.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Ethan Walker
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                         <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

<p style={{fontSize: "11px", fontStyle: "italic"}}>
   "When I followed this path, I went from selling clothes online to earning $8,000/month as a Full Stack Developer."
   <br/>
   <b>
      – Ethan Walker, former beginner and now Developer at an international company.
   </b>
</p>
                            </div>
                          </div>
                        
                        
                        
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/team/faces/face_1.webp" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Lily Matthews
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                           <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

<p style={{fontSize: "11px", fontStyle: "italic"}}>
   "I'm a mother of two children and worked as an elementary school teacher.
At 30, I thought it was too late to change careers…
Today I work as a Full Stack Developer for a German company
and earn $6,800/month from home! The best part: I watch my children grow
while designing educational applications used by thousands of students."

   <br/>
   <b>
     Lily Matthews – , program graduate in 4 months.
   </b>
</p>
                            </div>
                          </div>
                        
                        
                        
                          <div className="d-flex my-3" style={{borderRadius: "15px", boxShadow: "5px 2px 9px 9px #dee2e6", padding: "5px", alignItems: "flex-start"}}>
                          <img className="ml-1" style={{borderRadius: "30px", marginRight: "5px"}} height="65px"
                            src="/assets/images/dojopy/01920912.png" 
                            />
                            <div className="ml-2 mt-2">
                              <h5 style={{fontStyle: "italic"}} className="my-0">Emily Parker
                              <FaFacebookSquare style={{marginLeft: "5px", fontSize: "20px", color: "#1877F2"}}/>
                        
                                <span style={{marginLeft: "5px", fontSize: "13px", color: "gray"}}></span>
                              </h5>
                        <p className="my-0"><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/><FaStar style={{color: "orange"}}/></p>

<p style={{fontSize: "11px", fontStyle: "italic"}}>
   "I always thought a career in technology was out of my reach. However, the bootcamp not only taught me technical skills, but also how to apply them in the real world. Now I work for an educational technology company and earn more than $6,300/month. The best part is that I can work remotely and spend quality time with my son."

   <br/>
   <b>
     Emily Parker – ., program graduate in 4 months.
   </b>
</p>
                            </div>
                          </div>
                          
                          
                             <div className="mt-4 text-center">
                    <img alt="" height={window.type_device ? "80px": "89px"} src="/assets/images/dojopy/truspilot.png" />
                    <img alt="" height={window.type_device ? "80px": "89px"} src="/assets/images/dojopy/dojofullstack_report.png" />
                    <span style={{display: "inline-block", marginLeft: "5px", color: "white", "font-size": "13px", "paddingTop": "20px", fontStyle: "italic"}}>  
                   Guaranteed Excellence in Training
                    </span>
                    </div>

                          </div>
              


                    </div>


                    
                </div>
    </>
    }











          

                {/* <Modal show={this.state.isOpen2} size="md" onHide={this.openModal2} style={{zIndex: "9999999999"}} >
                <span style={{textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.openModal2()} style={{ cursor: "pointer", fontSize: "35px", marginLeft: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                    <Modal.Body>
                    <div className="about-inner inner">
                        <div className="section-title">
                            <p>
No te preocupes. Nuestros programas son aptos para principiantes y no requieren ningún conocimiento previo ni hay limite de edad.
Además, no estarás solo. Nuestro equipo estará a tu lado para guiarte en el proceso, ayudarte a establecer objetivos y a tener éxito.
                            </p>
                            <p>
                                <b>Instalar Zoom:</b>
                                <img style={{borderRadius: "10px"}} alt="canal zoom" height="55px" src="/assets/images/dojopy/zoom_.webp"></img>
                            </p>
                    </div>
                    </div>
                    </Modal.Body>
                    <Modal.Footer style={{"justify-content": "center"}}>
                    <button className="rn-btn" onClick={this.openModal2}>{true ? "Cerrar": "Close"}</button>
                    </Modal.Footer>
                </Modal> */}


     

    

                <Modal show={this.state.isOpen2} size="md" onHide={this.openModal2} style={{zIndex: "9999999999"}} >
                <span style={{textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.openModal2()} style={{ cursor: "pointer", fontSize: "39px", marginLeft: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                    <Modal.Body>
                    <div className="about-inner inner pt-3">
                        <div className="section-title">

                            <h3 class="title text-black px-0 my-0 text-center" style={{fontSize: window.type_device ? "30px": "37px", lineHeight: "1.4"}}>
                              Únete a la <br/> Masterclass  Gratuita
                             </h3>
                             <div className=" mx-auto" style={{width: window.type_device ? "197px": "395px", height: "6px", backgroundColor: "gold", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>

                            <p style={{fontSize: window.type_device ? "17px": "18px", textAlign: "left"}}>
                                <b style={{display: "inline-block"}}> ¿Quieres trabajar en tecnología pero no sabes por dónde empezar? </b>
                                En nuestro Masterclass "De Cero a Desarrollador Full Stack Developer" descubrirás:
                            </p>
                            <ul >
                                <li style={{fontSize: window.type_device ? "16px": "17px" }}>✅ Cómo iniciar en programación sin experiencia previa</li>
                                <li style={{fontSize: window.type_device ? "16px": "17px" }}>✅ El paso a paso para crear tu primera aplicación web y móvil desde cero.</li>
                                <li style={{fontSize: window.type_device ? "16px": "17px" }}>✅ <b> Un descuento exclusivo, disponible por tiempo limitado. </b>  </li>
                            </ul>

<div style={{justifySelf: "center", textAlign: "center", marginTop: "13px"}}>
<a target="_blank" href={"/masterclass" + window.location.search} style={{textDecoration: "none", color: "white", textAlign: "center"}}>
  <button
    // onClick={() => document.querySelector('#registro').scrollIntoView({ behavior: 'smooth' })}
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "20px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg,#ffe26d,#f5c918)",
      color: "black",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
  >
    <AiOutlineRight className="mr-2" />
    Ir a la Masterclass
  </button>
  </a>

    <h3
                  className="my-0 text-center"
                       style={{borderRadius: "9px", color: "black", fontWeight: "normal", display: "block", padding: "10px", "padding-left": "15px", "padding-right": "15px", "font-size": window.type_device ? "15px": "16px" }}>
                     <FaFilm className="mr-2" />
     Acceso exclusivo solo por hoy
                      </h3>
</div>

                       
                    </div>
                    </div>
                    </Modal.Body>
            
                </Modal>



                <Modal show={this.state.isOpenSuscribe} size="xl" onHide={() => this.setState({isOpenSuscribe: false, selectFecha: false})} style={{top:  window.type_device ? "1%": "15%", zIndex: "999999"}}>

                <span style={{marginLeft: "5px", marginTop: "5px", textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpenSuscribe: false, selectFecha: false}) } style={{ cursor: "pointer", fontSize: "41px", marginLeft: "12px", marginRight: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                <Modal.Body className="body-evento">

                <div className="inner">
                    <div className="contact-form--1">
                            <div className="row">
                                <div className="col-12 col-md-7 px-2">
                                <h3 className="mb-1 text-center" style={{fontSize: window.type_device ? "26px": "39px"}}>
                                   Empieza tu inscripción al Bootcamp Full Stack Developer
                                </h3>

                                <div className="mx-auto" style={{width: window.type_device ? "190px": "290px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                    <>
                                    <h5 className="my-2" style={{fontWeight: "500", fontSize: window.type_device ? "17px": "18px"}}>
                                    Inscríbete ahora y accede inmediatamente al Bootcamp.
</h5>

                                    {!window.type_device && this.renderInfoBootcamp()}


                                    {/* formulario */}
                                    {window.type_device &&
                                    <>
<div data-aos="fade-right" className="col-12 col-md-6 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={this.onSubmit} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Registration Information
    </h3>
</div> 
        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 


<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>

</div>  

 


<button
    id="submit-contacto"
    className="btn-efect"
    type="submit" name="submit-contacto"  style={{padding: "10px 20px", fontFamily: "'Poppins',sans-serif", width: "100%", fontSize: "23px", display: "block", margin: "auto", textTransform: "capitalize"}}>




{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
Start Enrollment
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "13px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 13, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>


            </form>
                    </div>
            

        </div>
                                    </>
                                    }

                           {window.type_device && this.renderInfoBootcamp()}

                                 
                                    </>
                                </div>

     {/* formulario */}
{!window.type_device &&
<>
                                <div className="col-12 col-md-5" style={{paddingTop: "20px"}}>
                           
                    <div data-aos="fade-right" className="col-12 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={this.onSubmit} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Registration Information
    </h3>
</div> 

        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 

<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp (para coordinar la llamada):
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>
<div>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="text"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="N.º Celular"
    />
 </label>
</div>
</div> 




<button
    id="submit-contacto"
    className="btn-efect"
    type="submit" name="submit-contacto"  style={{padding: "10px 20px", fontFamily: "'Poppins',sans-serif", width: "100%", fontSize: "23px", display: "block", margin: "auto", textTransform: "capitalize"}}>




{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
Start Enrollment
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "14px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 15, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>


            </form>
                    </div>
            

        </div>
        
                                   
                                </div>
 </>
                                    }

                                </div>
                        </div>
                        
                        </div>


                    </Modal.Body>

                </Modal>




        <Modal show={this.state.isOpenMett} size="xl" onHide={() => this.setState({isOpenMett: false, selectFecha: false})} style={{top:  window.type_device ? "1%": "15%", zIndex: "999999"}}>

                <span style={{marginLeft: "5px", marginTop: "5px", textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpenMett: false, selectFecha: false}) } style={{ cursor: "pointer", fontSize: "41px", marginLeft: "12px", marginRight: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                <Modal.Body className="body-evento">

                <div className="inner">
                    <div className="contact-form--1">
                            <div className="row">
                                <div className="col-12 col-md-7 px-2">
                                <h3 className="mb-1 text-center" style={{fontSize: window.type_device ? "30px": "39px"}}>
                                   Solicita tu <br/> Beca Parcial
                                </h3>

                                <div className="mx-auto" style={{width: window.type_device ? "190px": "290px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                    <>
                                    <h5 className="my-2" style={{fontWeight: "500", fontSize: window.type_device ? "16px": "17px"}}>
Conviértete en Full Stack Developer con nuestra metodología práctica y mentalidad innovadora.  <br/>
<b>Solicita tu beca parcial ahora y accede al programa con un 70% de descuento.  </b>

</h5>

   



                                    {/* formulario */}
                                    {window.type_device &&
                                    <>
<div data-aos="fade-right" className="col-12 col-md-6 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, false )} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>

 {/* <div className="section-title mt-3 mb-1 d-flex">
    <h3 className="title mb-2" style={{paddingLeft:  window.type_device ? "1px" : "9px"}}>
      Registration Information
    </h3>
</div>  */}
        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 


<div className="text-left mt-1" >
    <b style={{fontSize: "15px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="987654321"
    />
 </label>
</div>

</div>  





<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      color: "white",
      border: "none",
      outline: "none"
    }}
    className="cta-button"
    >



{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
 Solicitar mi beca parcial
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "13px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 13, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
          
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Roadmap personalizado para tu carrera tech </p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Metodología práctica con proyectos reales</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Oportunidades laborales y salario esperado</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Acceso a nuestra comunidad de desarrolladores</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Mentorías 1:1 con expertos de la industria</p>
      
        </div>

            </form>
                    </div>
            

        </div>
                                    </>
                                    }

                                 
                                    </>
                                </div>

     {/* formulario */}
{!window.type_device &&
<>
                                <div className="col-12 col-md-5" style={{paddingTop: "20px"}}>
                           
                    <div data-aos="fade-right" className="col-12 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, false ) } className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>



        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Nombre:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hola! ¿Cuál es tu nombre?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 ¿Cuál es tu Email?"
                    />
            </label> 

<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        WhatsApp:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"País"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>
<div>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="text"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="N.º Celular"
    />
 </label>
</div>
</div> 



<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "linear-gradient(180deg, #9b37f2, #7a12d4)",
      color: "white",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
    
     >


{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
Solicitar mi beca parcial
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "14px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 15, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 Protegemos tu información.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Roadmap personalizado para tu carrera tech </p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Metodología práctica con proyectos reales</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Oportunidades laborales y salario esperado</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Acceso a nuestra comunidad de desarrolladores</p>
                <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Mentorías 1:1 con expertos de la industria</p>
      
        </div>

            </form>
                    </div>
            

        </div>
        
                                   
                                </div>
 </>
                                    }

                                </div>
                        </div>
                        
                        </div>


                    </Modal.Body>

                </Modal>





        <Modal show={this.state.isOpenBrochure} size="xl" onHide={() => this.setState({isOpenBrochure: false, selectFecha: false})} style={{top:  window.type_device ? "1%": "15%", zIndex: "999999"}}>

                <span style={{marginLeft: "5px", marginTop: "5px", textAlign: "left", "color":"slateblue"}}> <IoCloseCircleOutline onClick={() => this.setState({isOpenBrochure: false, selectFecha: false}) } style={{ cursor: "pointer", fontSize: "41px", marginLeft: "12px", marginRight: "12px", marginTop: "12px", color: "slateblue"}} /> </span>

                <Modal.Body className="body-evento">

                <div className="inner">
                    <div className="contact-form--1">
                            <div className="row">
                                <div className="col-12 col-md-7 px-2">
                                <h3 className="mb-1 text-center" style={{fontSize: window.type_device ? "26px": "39px"}}>
                                  Download the Full Stack Developer Bootcamp Brochure
                                </h3>

                                <div className="mx-auto" style={{width: window.type_device ? "190px": "290px", height: "6px", backgroundColor: "#ffcb48", marginBottom: "17px", transform: "rotate(178deg)", marginTop: "-2px"}}></div>
                                    <>
                                    <h5 className="my-2" style={{fontWeight: "500", fontSize: window.type_device ? "16px": "17px"}}>
Discover how to become a Full Stack Developer in record time with our practical approach and innovative mindset.


</h5>

   



                                    {/* formulario */}
                                    {window.type_device &&
                                    <>
<div data-aos="fade-right" className="col-12 col-md-6 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, true )} className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>


        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Name:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hello! What's your name??"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 What is your email?"
                    />
            </label> 


<div className="text-left mt-1" >
    <b style={{fontSize: "15px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        Phone:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"Country"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>

<div style={{width: "80%"}}>
<label htmlFor="Phone">
    <input
    style={{background: "white"}}
    type="tel"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="+1987654321"
    />
 </label>
</div>

</div>  





<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      color: "white",
      border: "none",
      outline: "none",
      background: "#1f1f25"
    }}
    className="cta-button"
    >



{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    
 Download syllabus
    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "13px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 13, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 We protect your information.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
          
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Personalized roadmap for your tech career </p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Practical methodology with real projects</p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Job opportunities and expected salary</p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Access to our developer community</p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ 1:1 mentoring with industry experts</p>
      
        </div>

            </form>
                    </div>
            

        </div>
                                    </>
                                    }

                                 
                                    </>
                                </div>

     {/* formulario */}
{!window.type_device &&
<>
                                <div className="col-12 col-md-5" style={{paddingTop: "20px"}}>
                           
                    <div data-aos="fade-right" className="col-12 px-1" style={{marginBottom: "25px"}}>
                <div style={{textAlign: "center", padding: "5px", boxShadow: "rgba(50, 27, 98, 0.47) 6px 5px 15px 0px", border: "", borderRadius: "20px" }}>

            <form onSubmit={(e)  => this.onSubmit(e, true ) } className="px-1" style={{paddingTop: "10px", paddingBottom: "10px" }}>



        <label className="col-12 text-left font-weight-bold" htmlFor="nameDojo">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Name:
            </span>
            <input
            id='nameDojo'
            style={{background: "white", marginBottom: "7px"}}
            type="text"
            name="name"
            value={this.state.Name}
            onChange={(e) => this.setState({ Name: e.target.value})}
            placeholder= {"👋 Hello! What's your name?"}
            />
        </label>

           <label className="mb-2 col-12 text-left font-weight-bold" htmlFor="item02">
            <span style={{fontSize: "15px", color: "black", fontWeight: "600"}}>
            Email:
            </span>
                <input
                    style={{background: "white", marginBottom: "3px"}}
                    type="email"
                    name="email"
                    id="item02"
                    value={this.state.Email}
                    onChange={(e)=>{this.setState({Email: e.target.value});}}
                    placeholder="📧 What is your email?"
                    />
            </label> 

<div className="text-left mt-1" >
    <b style={{fontSize: "14px", marginLeft: "16px", color: "black", fontWeight: "600"}}>
        Phone:
    </b>
</div>

<div className="d-flex justify-content-center mx-2">

<div className="mx-2 mt-2">
    <Selectrix
    className="pais-inscription"
    height={300}
    onRenderOption={this.onRenderOption}
    onRenderSelection={this.onRenderSelection}
    placeHolderInside={true}
    placeholder={"Country"}
    customScrollbar={true}
    searchable={false}
    materialize={false}
    defaultValue={this.state.countryCode}
    options={KeyCountry}
    onChange={(value) => {
        // console.log("value.key", value.key);
        this.setState({"countryCode": value.key});
        if (this.state.Email){
            localStorage.setItem('email', this.state.Email);
        }
        if (this.state.Name){
            localStorage.setItem('name', this.state.Name);
        }
        if (this.state.Phone){
            localStorage.setItem('phone', this.state.Phone);
        }
    } }
    />

</div>
<div>
<label htmlFor="Phone">
    
    <input
    style={{background: "white"}}
    type="text"
    name="phone"
    id="Phone"
    value={this.state.Phone}
    onChange={(e) => {
        this.setState({ Phone: e.target.value });
    }}
    placeholder="+1987654321"
    />
 </label>
</div>
</div> 




<button
    id="submit-contacto"

    type="submit" name="submit-contacto"
    style={{
      textShadow: "none",
      cursor: "pointer",
      fontWeight: "bold",
      fontSize: "19px",
      padding: "10px 19px",
      borderRadius: "20px",
      background: "#1f1f25",
      color: "white",
      border: "none",
      outline: "none"
    }}
    className="btn-efect-live"
    
     >


{!this.state.loadingEnroll  && <b style={{fontSize: "23px"}}>
    Download syllabus    

    </b> }

{this.state.loadingEnroll  &&
                <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{fontSize: "20px", marginRight: "8px"}}
                />
}

</button>


   
   
<div className="row mt-3">
                    <div className="col-12 mx-3" style={{color: "gray", fontSize: "14px", textAlign: "left"}}>
                    <label htmlFor="checkNotify" style={{float: "left"}}>
                        <input
                            style={{width: 15, float: "left", marginTop: "-10px", marginRight: "5px", marginBottom: "1px"}}
                            defaultChecked={true}
                            type="checkbox"
                            name="checkNotify"
                            id="checkNotify"
                        />
                        <span>🔒 We protect your information.</span>
                    </label>
                    </div>
                </div>

    <div class="benefits-list">
          
           <p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Personalized roadmap for your tech career </p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Practical methodology with real projects</p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Job opportunities and expected salary</p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ Access to our developer community</p>
<p style={{marginBottom: "3px", fontSize: "14px"}}>✓ 1:1 mentoring with industry experts</p>
      
        </div>

            </form>
                    </div>
            

        </div>
        
                                   
                                </div>
 </>
                                    }

                                </div>
                        </div>
                        
                        </div>


                    </Modal.Body>

                </Modal>

{this.state.showWeb && 

                <div className="rn-brand-area bg_color--1 ptb--10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 px-0">


                        <div class="section-title mb--25 mb_sm--0 text-center">
                            <h3 class="title text-dark" style={{lineHeight: "normal"}}>
                            OUR GRADUATES WORK AT WELL-KNOWN INTERNATIONAL COMPANIES
                             </h3>

                             <div className="d-flex justify-content-center">
                              <img className="col-12 col-md-6 w-100 img-fluid px-0" src="/assets/images/dojopy/brands_2025.png" alt="" srcset="" />
                             </div>
                        </div>

                            </div>
                        </div>
                    </div>
                </div>
    }





{this.state.showWeb && 

<div className="rn-testimonial-area bg_color--1 ptb--40" style={{"padding": "10px"}}>
    <div className="container">
            <div className="rn-testimonial-area bg_color--1 ptb--80" style={{"padding-bottom": "30px"}}>
                    <div className="container">
                        <TestimonialTree langUS={this.state.langUS} />
                    </div>
                </div>
    </div>
</div>
    }





{this.state.showWeb && 

  <div className="rn-team-area ptb--40 bg_color--1" id="team" data-aos="fade-right" >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title service-style--3 text-center mb--25 mb_sm--0">
                                        <h2 className="title">{true ? "Nuestro Equipo": "Our team"} </h2>
                                        <p>{true ? "Nos apasiona la tecnológica y los desafíos de este mundo cambiante.": "We are passionate about technology and the challenges of this changing world."}  </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{justifyContent: "center"}}>
                                <TeamFull column="col-3 col-md-1" />
                            </div>
                        </div>
                </div>
    }






{this.state.showWeb && 
    <PreguntasEmpleo langUS={"US"} bootcampSlug={this.state.bootcampSlug} />
    }






{this.state.showPrice && this.state.showWeb && this.state.price_completo_2 &&

      <div 
         onClick={() => {
            const element = document.querySelector('#fechas');
            element.scrollIntoView({ behavior: 'smooth' });
         window.fbq('track', 'AddToCart', {
        value: 2000,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
}}
      className="floating-button-container btn-efect-live px-2" style={{borderRadius: 0, backgroundColor: "white", width: "100%"}}>

        <div className="floating-button" style={{gap: window.type_device ? "1px": "30px", padding: "1px", width: "100%", display: "flex", justifyContent: window.type_device ? "space-between": "center" } }>

<div>
    <div className="price-info">
             <div className="old-price"> <del> {this.state.price_completo_regular_2} </del> </div>
            {this.state.porcentajeDescuento &&  <div className="discount-badge"> {this.state.porcentajeDescuento}  </div> }
        </div>
         <div className="new-price mb-1">
            {this.state.price_completo_2}
            </div>

    </div>

<div className="price-container" style={{justifyContent: window.type_device ? "center": "center", gap: window.type_device ? "": "30px"}}>
  


    <div className="d-flex" style={{flexDirection: "column", alignSelf: "center"}}>

            <button
            onClick={() => {
                const element = document.querySelector('#fechas');
            element.scrollIntoView({ behavior: 'smooth' });
                window.fbq('track', 'AddToCart', {
                    value: 2000,                 // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp'
                });
            }}
            className="cta-button">
             Join the Bootcamp
            </button> 
      
    
    </div>

</div>


        </div>

        </div>
} 


{/* 
      <div 
         onClick={() => {
            this.setState({isOpenMett: true});
            // const element = document.querySelector('#fechas');
            //      element.scrollIntoView({ behavior: 'smooth' });
         window.fbq('track', 'AddToCart', {
        value: 2000,                 // Valor total de la compra
        currency: 'USD',               // Moneda utilizada (ISO 4217)
        content_type: 'product',       // Tipo de contenido
        content_ids: ['bootcamp'],  // ID del producto o identificador
        content_name: 'bootcamp'
      });
}}
      className="floating-button-container btn-efect-live" style={{borderRadius: 0, backgroundColor: "white", width: "100%"}}>

        <div className="floating-button" style={{padding: "1px", width: "100%" } }>

<div className="price-container" style={{width: "100%", justifyContent: window.type_device ? "center": "center", gap: window.type_device ? "": "30px"}}>

    <div className="d-flex" style={{flexDirection: "column", alignSelf: "center"}}>

            <button
                onClick={() => {
                this.setState({isOpenMett: true});
                window.fbq('track', 'AddToCart', {
                    value: 2000,                 // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp'
                });
            }}
                className="cta-button" style={{ color: "white"}}>
                <GoRocket className="mr-1" />  Acceder a Beca Parcial
            </button> 
    
    </div>

</div>

        </div>

        </div> */}





{this.state.showWeb && 
                 <FooterTwo langUS={true} fbclid_short_code={this.state.fbclid_short_code} />
    }
                 
            </Fragment>
        )
    }




    runtDiscountHot(country){
        console.log("module runDiscountFlash!");

        const getCookieValue = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        const discount60mValue = getCookieValue(`discount-temporal-${this.state.bootcampSlugDescuento}`);
        const discount24hValue = getCookieValue(`discount-reboot-${this.state.bootcampSlugDescuento}`);

        if (discount60mValue){
            console.log("DESCUENTO ACTIVO!");
            const discount60mDate = new Date(parseInt(discount60mValue, 10));
            // console.log(discount60mDate);
            this.setState({timeCounter: discount60mDate})
            return;
        }


        if ( !discount60mValue && !discount24hValue){
            console.log("CREANDO DESCUENTO!");

            const fechaActual = new Date();
            const fechaActual2 = new Date();
    
            const minutes = 60*24;
            const houresReboot = 48;
    
            fechaActual.setTime(fechaActual.getTime() +  (minutes * 60 * 1000) );
            fechaActual2.setTime(fechaActual2.getTime() +  (houresReboot * 60 * 60 * 1000) );
    
            document.cookie = `discount-temporal-${this.state.bootcampSlugDescuento}=${fechaActual.getTime()};expires=${fechaActual.toUTCString() }; path=/`;
            document.cookie = `discount-reboot-${this.state.bootcampSlugDescuento}=${fechaActual2.getTime()};expires=${fechaActual2.toUTCString() }; path=/`;
            this.setState({timeCounter: fechaActual})
        } else if (!discount60mValue && discount24hValue){
            console.log("FINALIZO EL DESCUENTO!");
            this.setState({showDeadLine: false});
        }
       
    }

    

    componentDidMount() {

        if (window.location.pathname.includes("/ca")){
            this.setState({bootcampSlug: "fullstack-ca", bootcampSlugDescuento: "fullstack-ca", countryCode: "CA"});
        }


        // if (window.location.pathname.includes("beca50")){
        //     const texto = "Hola, información sobre la beca parcial Full Stack Developer.";
        //     window.location.href = `https://api.whatsapp.com/send?phone=51936670597&text=${texto}`;
        //     return;
        // }


        if (window.location.pathname.includes("descuento")){
            this.setState({bootcampSlug: "fullstack-descuento", bootcampSlugDescuento: "fullstack-descuento"});
        }


        // if (window.location.pathname.includes("masterclass")){
        //     this.setState({showWeb: false, bootcampSlug: "fullstack-descuento", bootcampSlugDescuento: "fullstack-descuento"});


        //         // Esperar 9 minutos para mostrar el botón de WhatsApp
        //         this.sleep(60000*10).then(r => {
                    
        //             window.fbq('track', 'ViewContent');

        //             this.setState({showWeb: true});
        //             document.getElementById('whatsapp').style.display='block';
        //                 const timerBar = document.getElementById('counter-deadline');
        //             const originalOffset = timerBar.offsetTop;
        //             window.addEventListener('scroll', () => {
        //             if (window.scrollY > originalOffset) {
        //             timerBar.classList.add('sticky');
        //             } else {
        //             timerBar.classList.remove('sticky');
        //             }
        //             });
        //         })

        //         //demo
        //         // this.sleep(7000).then(r => {
        //         //     this.setState({showWeb: true});
        //         //     document.getElementById('whatsapp').style.display='block';

        //         //     const timerBar = document.getElementById('counter-deadline');
        //         //     const originalOffset = timerBar.offsetTop;
        //         //     window.addEventListener('scroll', () => {
        //         //     if (window.scrollY > originalOffset) {
        //         //     timerBar.classList.add('sticky');
        //         //     } else {
        //         //     timerBar.classList.remove('sticky');
        //         //     }
        //         //     });
        //         // })
        // }

        this.fechEventping();
        this.fetchPricingData();


    }


    async fechEventping(){
        const fbclid = this.getFbclid();
        if (fbclid){
            const fbclidFormateado = this.generarFBC(fbclid);
            // console.log("fbclid", fbclidFormateado);
            const codigoCorto = this.generarCodigoCorto(fbclid);
            // console.log("codigoCorto", codigoCorto);
            this.setState({"fbclid_short_code": codigoCorto});
            this.eventPing(codigoCorto, fbclidFormateado);
        }
    
    }

    async fetchPricingData() {


        axios.get("https://ipapi.co/json/")
            .then((response) => {
                const dataPriceIP = response.data;
                if (!dataPriceIP.country_code) throw "api error";
                const countryCode = dataPriceIP.country_code.toUpperCase();
                if (countryCode === "CA") {
                    this.setState({bootcampSlug: "fullstack-ca", bootcampSlugDescuento: "fullstack-ca", countryCode: "CA"});
                }
            })
            .catch((error) => {
                console.error("Error fetching IP info:", error);
                // Opcional: puedes redirigir a una página por defecto o mostrar un mensaje
            });



        const pathdata = window.location.pathname;
        // console.log('pathdata', pathdata);
        const url = new URL(window.location.href);
        const session_id = url.searchParams.get('session_id');
        const invoice_id = url.searchParams.get('invoice_id');
        const checkout_mount = url.searchParams.get('mount');
    

        if (pathdata.includes("payment-success")){
            // console.log("enviar evento pixel pago completado");

            if (session_id || invoice_id){
                console.log("Log ADS: session_id", session_id || invoice_id, parseInt(checkout_mount) || 497);
                window.fbq('track', 'Purchase', {
                    value: parseInt(checkout_mount) || 147,   // Valor total de la compra
                    currency: 'USD',               // Moneda utilizada (ISO 4217)
                    content_type: 'product',       // Tipo de contenido
                    content_ids: ['bootcamp'],  // ID del producto o identificador
                    content_name: 'bootcamp',
                    eventID: session_id || invoice_id,
                });
            }

        window.fbq('track', 'Lead', {
            content_name: 'Purchase Bootcamp',
            content_category: 'Full Stack Developer Online'
          });
      

            if (invoice_id){
                // Mostrar el valor en la consola
              window.open("https://plataforma-dojopy-media.s3.us-east-1.amazonaws.com/INVOICES/" + invoice_id + ".pdf", '_blank').focus();
            }

            // Obtener la URL actual
            // Leer el parámetro 'session_id'
    
     
        }


        if (pathdata.includes("masterclass")){
            const iframe = document.getElementById('iframe-video');
            const estilo = window.getComputedStyle(iframe);
            const anchoExacto = parseInt(estilo.width, 10)
        
            const windowWidth = window.type_device ? window.innerWidth : anchoExacto;
            // Calcular el alto basado en la proporción 16:9
            const aspectRatio = 16 / 9;
            const height = windowWidth / aspectRatio;
            iframe.style.height = height  + 'px';

       
          
   

        } else {

 

            // if (!window.location.pathname.includes("beca") ){
            //     document.getElementById('whatsapp').style.display='block';
            // } 

        }





        const isParameterPresent = (param) => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.has(param);
        }

        // const isDiscountActive = isParameterPresent("discount");
        // if (isDiscountActive){
        //     console.log("Descuento activo flex-now!");
        //     this.setState({showDeadLine: true, bootcampSlug: "fullstack-especial", bootcampSlugDescuento: "fullstack-especial"})
        // }


        
        let fechaActual = new Date();

        try {
            const response = await axios.get("https://hiuaik2gocmwdeh2ub6lqz3hxq0ycvbe.lambda-url.us-east-1.on.aws/");
            let dataPrice = response.data;
            this.setState({pricingAPI: dataPrice})

   
            this.sleep(2500).then(r => {
                this.setState({showPrice: true});
            });

            if (window.location.pathname.includes("/ca")){
                this.setState({countryCode: "CA"});
                this.DynamicCountry("CA");
            } else {
                this.setState({countryCode: "US"});
                this.DynamicCountry("US");
            }
     
        } catch (error) {
            console.log(error);
          }


        this.sleep(120000).then(r => {
            toast.success("¡Geiler y Jhon ya se inscribieron, ahora es tu turno de unirte!");
        })


//         this.sleep(1000).then(r => {
//             toast.success(<>
//                <div className="row" >
//                <div className="d-flex mb-1 col-12" style={{borderRadius: "20px", padding: "5px", alignItems: "center"}}>
//     <img className="ml-1" style={{borderRadius: "20px", marginRight: "5px"}} height="65px" src="/assets/images/dojopy/1-face.webp" />
//     <div className="ml-2 mt-2">
//       <h5 style={{fontSize: "17px", color: "#1f1f25", fontStyle: "italic"}} className="my-0">Elon Musk
//         <span style={{marginLeft: "5px", fontSize: "13px", color: "mediumseagreen"}}>⭐⭐⭐</span>
//       </h5>
//       <p style={{fontSize: "11px", fontStyle: "italic"}}>estuvo genial recmomiendo!!! Acaba de inscribirse!.</p>
//     </div>
//   </div>
//                </div>
               
//             </>);
//         })


  


    // this.sleep(2000).then(r => {
    //     this.setState({showPayal: true})
    // })






        this.sleep(100).then(r => {
                this.setState({showBtnTemario: true});
            })


        const email = localStorage.getItem('email');
        const name = localStorage.getItem('name');
        const phone = localStorage.getItem('phone');
        const fbclid_short_code = localStorage.getItem('fbclid_short_code');

        if (email){
            this.setState({Email: email});
        }
        if (name){
            this.setState({Name: name});
        }
        if (phone){
            this.setState({Phone: phone});
        }

        if (fbclid_short_code){
            this.setState({fbclid_short_code: fbclid_short_code});
        }


    }

}


export default BootcampEnginierUSA;
